/* USE PROTECTION design: the product page's behaviour (sections/up-product.liquid; the look is the mockup's #produs).
 *
 * Wired to the live contracts of sections/product-rhode.liquid, ported, not reinvented:
 *   - case types from option1 (base = option1 minus ' MagSafe' / ' Transparent'; MagSafe is a toggle on the base),
 *     colours from the colour option + settings.color_swatch_config, Full-Shock the default when it is in stock;
 *   - every price face through the same chain as product-rhode (the cart transform's glossy / Slim charge map gpx,
 *     full-price mode dropping compare_at, the price-tier arm's shownPrice / ptAnchor / saleOn / ptOwnsFrame), so a
 *     returning arm re-prices this page exactly as it re-prices the live one;
 *   - THE ADD FLOW (product-rhode ~5168-5580, line for line): POST /cart/add.js {items, sections:'mini-cart'}, one
 *     retry on 429, non-OK = the visible error; the mystery gift rides with caseSku + 'Pentru husă' only when the cart
 *     holds no gift yet (fresh /cart.js), a failed gift attempt retries the case alone (mgf:<arm>); the -30% protector
 *     picks go through Storefront cartLinesAdd with the 'Reducere folie' attribute (one retry, never unpriced), then
 *     cart:refresh with the add's sections, the drawer, cart:updated; variant:added is deliberately NOT fired (the
 *     native GA4 pixel owns add_to_cart);
 *   - measurement: mf_case_add + the case-add beacon, ups:pdp_add_*, ups:*_pick, upsell_select(_v2), prba:, pdpt:, gal2:
 *     and the gal:b_* content steps on lifestyle pages, the pdpc:* page keys (pdpc:face_up marks this face). The hooks
 *     mf-track.js binds by itself (.pr-type, .pr-sw, [data-pr-up], [data-pr-magsafe-btn], [data-pr-cta],
 *     [data-pr-float], select[data-pr-device], .pr-acc__head, [data-pr-stage]) are on the markup.
 * ES5 on purpose (the theme's live scripts are): no arrow functions, no template literals.
 */
(function () {
  'use strict';
  var W = window, D = document;
  var root = D.querySelector('[data-upd]');
  if (!root || root.__upd) { return; }
  root.__upd = true;
  var dataEl = root.querySelector('[data-upd-data]');
  var data;
  try { data = JSON.parse(dataEl.getAttribute('data-upd-data')); } catch (e0) { return; }

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
  function push(ev, p) { try { if (W.mfTrackPush) { W.mfTrackPush(ev, p); } } catch (e) {} }
  function step(n) { push('mf_nav_step', { mf_step: n }); }
  var sentK = {};
  function step1(n) { if (sentK[n] || !W.mfTrackPush) { return; } sentK[n] = 1; step(n); }
  var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ── money: window.mfMoney (snippets/mf-ctl-head - shop.money_format exactly as Liquid's | money; multistore
     2026-10-25, the local formatter is gone). The bare-number fallback only keeps the page alive without it. ── */
  function money(cents) { return W.mfMoney ? W.mfMoney(cents) : String((cents || 0) / 100); }
  /* the sticky bar's line in Black Friday mode: <s>original</s> -NN%, or the price */
  function bfLine(el, shown, cmp) {
    el.textContent = '';
    if (cmp > shown) {
      var s = D.createElement('s'), o = D.createElement('span');
      s.textContent = money(cmp); o.className = 'u-off'; o.textContent = '−' + Math.round((1 - shown / cmp) * 100) + '%';
      el.appendChild(s); el.appendChild(D.createTextNode(' ')); el.appendChild(o);
    } else { el.textContent = money(shown); }
  }
  /* ── copy: this store's mf.up.pdp.* strings (snippets/mf-l10n); '' before mf-l10n ran ── */
  function T(k, vars) { return W.mfT ? String(W.mfT(k, vars) || '') : ''; }

  /* swatch hexes - 'Name:#HEX' per line */
  var swatchMap = {};
  String(data.swatchConfig || '').split('\n').forEach(function (line) {
    var i = line.indexOf(':');
    if (i > 0) { swatchMap[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim(); }
  });

  var variants = data.variants || [];
  /* ── GLOSSY (Theme settings > Glossy összefűzés, owner 2026-10-24; data.gm only on a glossy + matt pair with the switch
     on - otherwise nothing below changes): ONE variant list, sections/product-rhode.liquid's GLOSSY MERGE verbatim -
     the matt Full-Shock* read as Slim-Shock* (suffixes kept), Pro-Shock* as is, the glossy variant as Full-Shock. Real
     id / sku / price / stock / image stay, so cart, caseSku and prices need no mapping; _gm = whose (g / m), _gb = the
     real base, _pt / _ph = its product. ── */
  var GMD = (data.gm && data.gm.g && data.gm.m) ? data.gm : null;
  if (GMD) {
    variants = [];
    (GMD.m.variants || []).forEach(function (v0) {
      var v = Object.assign({}, v0);
      var o1 = String(v.option1 || '');
      var b0 = o1.replace(' MagSafe', '').replace(' Transparent', '');
      v._gm = 'm'; v._gb = b0; v._pt = GMD.m.title; v._ph = GMD.m.handle;
      if (b0 === 'Full-Shock') { v.option1 = 'Slim-Shock' + o1.slice('Full-Shock'.length); }
      variants.push(v);
    });
    (GMD.g.variants || []).forEach(function (v0) {
      var v = Object.assign({}, v0);
      var o1 = String(v.option1 || '');
      v._gm = 'g'; v._gb = o1.replace(' MagSafe', '').replace(' Transparent', ''); v._pt = GMD.g.title; v._ph = GMD.g.handle;
      v.option1 = 'Full-Shock' + (o1.indexOf('MagSafe') !== -1 ? ' MagSafe' : '');
      if (!(v.featured_image && v.featured_image.src) && GMD.g.img) { v.featured_image = { src: GMD.g.img }; }
      variants.push(v);
    });
  }
  /* the cart transform's charge (gpx) is the price on every face; _ap = the admin price */
  var GPX = data.gpx || {};
  variants.forEach(function (v) { if (GPX[v.id] > 0) { v._ap = v.price; v.price = GPX[v.id]; } });
  /* the struck price of a charged glossy outside RO (gpc, the store's table compare; owner 2026-10-25: the glossy goes at
     -30% too where the store strikes its cases): it stands in for the variant's own compare_at */
  var GPC = data.gpc || {};
  variants.forEach(function (v) { if (GPC[v.id] > 0 && GPX[v.id] > 0 && GPC[v.id] > v.price) { v.compare_at_price = GPC[v.id]; } });
  /* full-price mode: compare_at never reaches a painter - no struck price, no -NN% anywhere on the page */
  var FP = data.fullPrice === true;
  if (FP) { variants.forEach(function (v) { v.compare_at_price = null; }); }
  var colorIndex = data.colorIndex;

  /* ── case-type grouping ── */
  var hasTypes = data.hasTypes === true && colorIndex !== 0;
  var BASE_ORDER = [], groups = {};
  variants.forEach(function (v) {
    if (!hasTypes) { return; }
    var o1 = v.option1 || '';
    var ms = o1.indexOf('MagSafe') !== -1;
    var base = o1.replace(' MagSafe', '').replace(' Transparent', '');
    if (!groups[base]) { groups[base] = { standard: [], magsafe: [] }; BASE_ORDER.push(base); }
    groups[base][ms ? 'magsafe' : 'standard'].push(v);
  });
  var METERS = {};
  String(data.typeMeters || '').split(',').forEach(function (c) {
    var kv = c.split('=>');
    if (kv.length !== 2) { return; }
    var m = parseFloat(kv[1]);
    if (kv[0].trim() && isFinite(m) && m > 0) { METERS[kv[0].trim()] = m; }
  });
  /* glossy pair: Slim-Shock's drop height (Theme settings mf_bg_slim_meter) and plate line (mf_bg_slim_line) */
  if (GMD) {
    var gmSm = parseFloat(String(GMD.slimMeter || '').replace(',', '.'));
    if (isFinite(gmSm) && gmSm > 0) { METERS['Slim-Shock'] = gmSm; }
    /* the glossy Full-Shock's own drop height (Theme settings mf_bg_glossy_meter, owner 2026-10-25: 5 m) */
    var gmGm = parseFloat(String(GMD.glossMeter || '').replace(',', '.'));
    if (isFinite(gmGm) && gmGm > 0) { METERS['Full-Shock'] = gmGm; }
    if (GMD.slimLine) { data.plates = data.plates || {}; data.plates['Slim-Shock'] = GMD.slimLine; }
  }
  /* the glossy pair's glossy type reads "Full-Shock Glossy" (owner 2026-10-27); the internal base stays "Full-Shock" */
  function dispT(t) { return (GMD && /^Full-Shock(\s|$)/.test(String(t || ''))) ? String(t).replace(/^Full-Shock/, 'Full-Shock Glossy') : t; }
  function meterTxt(base) { var m = METERS[base]; return m ? String(m).replace('.', ',') : ''; }
  /* finishes 'Type=>mat' (section setting type_finish): the card line, the type label and the shot's pill */
  var FINISH = {};
  String((GMD && GMD.finish) || data.typeFinish || '').split(',').forEach(function (c) {
    var kv = c.split('=>');
    if (kv.length === 2 && kv[0].trim() && kv[1].trim()) { FINISH[kv[0].trim()] = kv[1].trim().toLowerCase(); }
  });
  function finOf(base) { return FINISH[base] || ''; }
  function capFirst(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : ''; }

  if (data.beaconUrl) { W.__mfBeacon = data.beaconUrl; }
  W.setTimeout(function () { try { W.__mfOffered = offeredSet(); } catch (e) {} }, 1500);

  var state = { base: null, magsafe: false, color: null };
  function optVal(v, idx) { return v['option' + (idx + 1)]; }
  function availOf(list) { return list.filter(function (v) { return v.available; }); }
  function syncMagsafe() {
    if (!hasTypes) { return; }
    var g = groups[state.base];
    if (!g) { return; }
    var std = availOf(g.standard).length, ms = availOf(g.magsafe).length;
    if (state.magsafe && !ms && std) { state.magsafe = false; }
    else if (!state.magsafe && !std && ms) { state.magsafe = true; }
  }
  function currentPool() {
    if (!hasTypes) { return variants; }
    var g = groups[state.base] || { standard: [], magsafe: [] };
    var primary = state.magsafe ? g.magsafe : g.standard;
    var other = state.magsafe ? g.standard : g.magsafe;
    if (availOf(primary).length) { return primary; }
    if (availOf(other).length) { return other; }
    return primary.length ? primary : other;
  }

  /* ── the price-tier chain, verbatim from product-rhode (z0 today: every helper returns the plain price) ── */
  function ptCharge() { return (W.__mfPT && W.__mfPT.charge) || 0; }
  function ptFlat() { return (W.__mfPT && W.__mfPT.flat) || 0; }
  function shownPrice(base, cents) {
    if (cents == null) { return cents; }
    var pt = (W.__mfPT && W.__mfPT.off) || 0;
    if (pt > 0 && data.ptEligible === true && cents > pt) { cents = cents - pt; }
    var ptc = ptCharge();
    if (ptc > 0 && data.ptEligible === true) {
      var pcEff = Math.round((cents / 100) * (100 - ptc) / 100) * 100;
      var fl = ptFlat() * 100;
      if (fl > 0 && fl < pcEff) { pcEff = fl; }
      if (pcEff > 0 && pcEff < cents) { cents = pcEff; }
    }
    return cents;
  }
  function bfAnchor(eff, badge) {
    var a = Math.round((eff / 100) / ((100 - badge) / 100)) * 100;
    var tries = [a, a + 100, a - 100, a + 200, a - 200];
    for (var i = 0; i < tries.length; i++) {
      if (tries[i] > eff && Math.round((1 - eff / tries[i]) * 100) === badge) { return tries[i]; }
    }
    return a;
  }
  function ptAnchor(shown, catalog) {
    if (FP) { return 0; }
    var b = (W.__mfPT && W.__mfPT.pct) || 0;
    var g = (W.__mfPT && W.__mfPT.grp) || '';
    if (!(b > 0) || data.ptEligible !== true || !(shown > 0)) { return 0; }
    if (g === 'a') { return catalog > shown ? catalog : 0; }
    var flB = ptFlat() * 100;
    var pcRef = Math.round((catalog / 100) * (100 - ptCharge()) / 100) * 100;
    var flatBound = flB > 0 && flB < pcRef;
    if (!flatBound && b >= ptCharge()) { return catalog > shown ? catalog : 0; }
    var a = bfAnchor(shown, b);
    if (catalog > 0 && a > catalog) { a = catalog; }
    return a > shown ? a : 0;
  }
  if (data.ptEligible === true) { W.__mfPdpPB = data.priceBand; }
  function saleOn() {
    if (FP) { return false; }
    return W.__mfPTD === 'sale' && data.ptEligible === true &&
      (((W.__mfPT && W.__mfPT.off) || 0) > 0 || ((W.__mfPT && W.__mfPT.pct) || 0) > 0);
  }
  function ptOwnsFrame() {
    return data.ptEligible === true && ptCharge() > 0 && !(((W.__mfPT && W.__mfPT.pct) || 0) > 0);
  }
  /* the compare a face strikes for a variant (0 = none): the arm's anchor, else the merchant's compare_at */
  function compareFor(v, shown) {
    var eff = ptOwnsFrame() ? null : v.compare_at_price;
    var a = ptAnchor(shown, v.price);
    if (a > 0) { eff = a; }
    else if (saleOn() && v.price > shown && (!eff || eff < v.price)) { eff = v.price; }
    return (eff && eff > shown) ? eff : 0;
  }
  function groupMinPrice(base) {
    var g = groups[base];
    var pool = availOf(g.standard.concat(g.magsafe));
    if (!pool.length) { pool = g.standard.concat(g.magsafe); }
    var min = null;
    pool.forEach(function (v) { if (min === null || v.price < min) { min = v.price; } });
    return shownPrice(base, min);
  }
  function resolve() {
    var pool = availOf(currentPool());
    if (!pool.length) { pool = currentPool(); }
    if (colorIndex >= 0 && state.color) {
      for (var i = 0; i < pool.length; i++) { if (optVal(pool[i], colorIndex) === state.color) { return pool[i]; } }
    }
    return pool[0] || null;
  }
  function baseHasStock(base) {
    var g = groups[base];
    return !!(g && availOf(g.standard.concat(g.magsafe)).length);
  }
  function offeredSet() {
    var anyStock = BASE_ORDER.some(baseHasStock);
    return BASE_ORDER.filter(function (b) { return !anyStock || baseHasStock(b); }).slice().sort().join('+');
  }

  /* PDP TEST (2026-09-22, pool ['a'] today): arm B sells Full-Shock only */
  var PDP_B = hasTypes && W.__mfPDP === 'b' && !!groups['Full-Shock'];
  if (PDP_B) { BASE_ORDER = ['Full-Shock']; }
  /* default: Full-Shock, else Pro-Shock, else the first type in stock - and it renders first */
  if (hasTypes) {
    var eligible = BASE_ORDER.filter(baseHasStock);
    if (eligible.length >= 2) {
      var dealt = eligible.indexOf('Full-Shock') !== -1 ? 'Full-Shock' : eligible[0];
      try { W.sessionStorage.setItem('mf_def_t', dealt); } catch (eS) {}
      state.base = dealt;
      BASE_ORDER = [dealt].concat(BASE_ORDER.filter(function (b) { return b !== dealt; }));
      W.__mfDefault = dealt;
    } else {
      var pref = ['Full-Shock', 'Pro-Shock'].filter(function (b) { return BASE_ORDER.indexOf(b) !== -1 && baseHasStock(b); });
      if (pref.length) { state.base = pref[0]; }
      else { state.base = BASE_ORDER.filter(baseHasStock)[0] || BASE_ORDER[0] || null; }
    }
  }

  /* the page keys' kind and opening type (live C: K = solo / one / none, DEF = the opening type's slug) */
  function slugOf(base) { return base ? (/pro/i.test(base) ? 'pro' : (/full/i.test(base) ? 'full' : String(base).toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 10))) : ''; }
  var K = !hasTypes ? 'none' : (BASE_ORDER.filter(baseHasStock).length >= 2 ? 'solo' : 'one');
  var DEF = slugOf(state.base);

  /* ── DOM ── */
  var cta = $('[data-pr-cta]');
  var addLbl = $('[data-upd-addlbl]');
  var typesEl = $('[data-upd-types]');
  /* V3: the rows' container keeps its id (the opener bar's aria-controls) across the repaints */
  if (typesEl) { var tc3L0 = typesEl.querySelector('[data-tc3-list]'); if (tc3L0 && tc3L0.id) { typesEl.setAttribute('data-tc3-id', tc3L0.id); } }
  var msBtn = $('[data-pr-magsafe-btn]');
  var swEl = $('[data-pr-swatches]');
  var colRow = $('[data-upd-colrow]');
  var fBar = $('[data-pr-float]');
  var fCta = $('[data-pr-float-cta]');
  var gal = $('[data-upd-gal]');
  var mainImg = $('[data-upd-main]');
  var plate = $('[data-upd-plate]');
  if (!cta) { return; }

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(src, w) {
    if (!src) { return ''; }
    src = String(src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* the picture of a type for the card: that type in the chosen colour (Pro-Shock colours read 'Rim-Colour', so the
     tail after the last '-' matches too), else its first variant in stock, else any with an image */
  function colourKey(c) { c = String(c || '').replace(' MagSafe', ''); var i = c.lastIndexOf('-'); return (i > -1 ? c.slice(i + 1) : c).toLowerCase(); }
  function typeImg(base) {
    var g = groups[base]; if (!g) { return ''; }
    var list = (state.magsafe && g.magsafe.length ? g.magsafe : g.standard).concat(g.standard, g.magsafe)
      .filter(function (v) { return v.featured_image && v.featured_image.src; });
    var want = colourKey(state.color), hit = null;
    if (colorIndex >= 0 && want) { list.some(function (v) { if (colourKey(optVal(v, colorIndex)) === want && v.available) { hit = v; return true; } return false; }); }
    if (!hit) { list.some(function (v) { if (v.available) { hit = v; return true; } return false; }); }
    if (!hit) { hit = list[0]; }
    return hit ? hit.featured_image.src : '';
  }
  function typeCls(base) { return base === 'Full-Shock' ? ' u-full' : (base === 'Pro-Shock' ? ' u-pro' : ''); }

  /* a re-render replaces the buttons: the keyboard focus goes back to the button with the same key (live D's hadFocus) */
  function focusKey(box, attr) {
    var a = D.activeElement;
    return (a && box && box.contains(a) && a.getAttribute) ? a.getAttribute(attr) : null;
  }
  function refocus(box, attr, key) {
    if (key == null || !box) { return; }
    var list = box.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute(attr) === key) { try { list[i].focus({ preventScroll: true }); } catch (eF) { list[i].focus(); } return; }
    }
  }

  /* Theme settings > Tokválasztó (2026-10-24): data.tc only exists when the V2 card is chosen (up_tc_style
     'v2_slider'); without it the row below is painted exactly as before. V2 = the live RO type card in the new design:
     picture on top with the label ('Type=>label' setting) and the -% badge, name, down-arrow drop, finish chip, the
     price and the struck compare of the cheapest variant in stock (compareFor: the arm's anchor or compare_at). */
  var TC2 = !!(data.tc && data.tc.v2);
  /* V3 'Lenyitható' (up_tc_style 'v3_fold'): one card for the selected type, a full-width opener bar and the types as
     full-width rows behind it (the rows are the .pr-type buttons the selection handler and mf-track read). The
     benefit lines (rows only) come from the 'Type=>text | Type=>text' setting; an empty one prints nothing. */
  var TC3 = !!(data.tc && data.tc.v3);
  /* V4 (up_tc_style 'v4_cards', owner 2026-10-25): the V2 card, about two thirds of a phone wide, with the type's lines
     inside it (snippets/up-tc-lines.liquid, the same markup the server painted: data.tc.lines[type]) */
  var TC4 = !!(data.tc && data.tc.v4);
  /* B/C TEST (mf_ctl tc_test 'bc', owner 2026-10-27): the server painted V2 for everyone (data.tc.test); the c arm
     (window.__mfTc from snippets/mf-rank-head) is repainted as V3 by the first update() below, which then lifts the
     html.mf-tc-pend hide. TCA = the arm on this page ('' = no test); the tc* steps below are once per session. */
  var TCA = '';
  if (data.tc && data.tc.test && W.__mfTc && W.__mfTc.test === data.tc.test && (W.__mfTc.arm === 'b' || W.__mfTc.arm === 'c')) {
    TCA = W.__mfTc.arm;
    if (TCA === 'c') {
      TC2 = false; TC3 = true; TC4 = false;
      if (typesEl) {
        typesEl.classList.remove('u-types--v2', 'u-types--v4');
        typesEl.classList.add('u-types--v3');
        if (!typesEl.getAttribute('data-tc3-id')) { typesEl.setAttribute('data-tc3-id', 'u-tc3-list-c'); }
      }
    }
  }
  function tcOnce(n) {
    if (!TCA || !W.mfTrackPush) { return; }
    try { if (sessionStorage.getItem('mf_tco_' + n)) { return; } sessionStorage.setItem('mf_tco_' + n, '1'); } catch (eS) { if (sentK[n]) { return; } sentK[n] = 1; }
    step(n);
  }
  var TC_LAB = {}, TC_BEN = {};
  if (TC2 || TC3) {
    String(data.tc.labels || '').split(',').forEach(function (c) {
      var kv = c.split('=>'); if (kv.length === 2 && kv[0].trim()) { TC_LAB[kv[0].trim()] = kv[1].trim(); }
    });
    String(data.tc.benefits || '').split('|').forEach(function (c) {
      var kv = c.split('=>'); if (kv.length === 2 && kv[0].trim()) { TC_BEN[kv[0].trim()] = kv[1].trim(); }
    });
  }
  var tc3Open = false;
  var TC_AR = '<svg class="u-tc2-ar" viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.2v7.4M2.9 5.6 6 8.7l3.1-3.1M2 10.8h8"></path></svg>';
  function groupMinVar(base) {
    var g = groups[base];
    var pool = availOf(g.standard.concat(g.magsafe));
    if (!pool.length) { pool = g.standard.concat(g.magsafe); }
    var best = null;
    pool.forEach(function (v) { if (!best || v.price < best.price) { best = v; } });
    return best;
  }
  function tc2Card(base, on, img) {
    var m = meterTxt(base), fin = finOf(base), lab = TC_LAB[base] || '';
    var inStock = baseHasStock(base), v = inStock ? groupMinVar(base) : null;
    var shown = v ? shownPrice(base, v.price) : 0, cmp = v ? compareFor(v, shown) : 0;
    var off = cmp > shown ? Math.round((cmp - shown) * 100 / cmp) : 0;
    return '<button type="button" class="u-type' + typeCls(base) + ' pr-type u-tc2' + (on ? ' is-active' : '') + '" data-t="' + esc(base) + '" aria-pressed="' + on + '">' +
      '<span class="u-tc2-pic">' + (lab ? '<span class="u-tc2-tag">' + esc(lab) + '</span>' : '') + (off > 0 ? '<span class="u-tc2-off">-' + off + '%</span>' : '') +
      (img ? '<img src="' + esc(sized(img, 300)) + '" alt="" width="104" height="156">' : '') + '</span>' +
      '<span class="u-tc2-t"><b class="pr-type__name">' + esc(dispT(base)) + '</b><span class="u-tc2-m">' +
      (m ? '<span class="u-tc2-dr">' + TC_AR + m + ' m</span>' : '') + (fin ? '<span class="u-tc2-fin">' + esc(fin) + '</span>' : '') + '</span>' +
      '<span class="u-tc2-p"><span class="u-tp">' + (inStock ? money(shown) : esc(data.soldOutLabel)) + '</span>' + (off > 0 ? '<s>' + money(cmp) + '</s>' : '') + '</span></span>' +
      (TC4 && data.tc.lines && data.tc.lines[base] ? data.tc.lines[base] : '') + '</button>';
  }

  var TC3_AR = '<svg class="u-tc3-ar" viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.2v7.4M2.9 5.6 6 8.7l3.1-3.1M2 10.8h8"></path></svg>';
  function tc3Parts(base) {
    var m = meterTxt(base), fin = finOf(base), lab = TC_LAB[base] || '', ben = TC_BEN[base] || '';
    var inStock = baseHasStock(base), v = inStock ? groupMinVar(base) : null;
    var shown = v ? shownPrice(base, v.price) : 0, cmp = v ? compareFor(v, shown) : 0;
    var off = cmp > shown ? Math.round((cmp - shown) * 100 / cmp) : 0;
    return {
      lab: lab ? '<span class="u-tc3-tag">' + esc(lab) + '</span>' : '',
      meta: '<span class="u-tc3-m">' + (m ? '<span class="u-tc3-dr">' + TC3_AR + m + ' m</span>' : '') + (fin ? '<span class="u-tc3-fin">' + esc(fin) + '</span>' : '') + '</span>',
      ben: ben ? '<span class="u-tc3-ben">' + esc(ben) + '</span>' : '',
      price: (off > 0 ? '<span class="u-tc3-off">-' + off + '%</span>' : '') + '<span class="u-tp">' + (inStock ? money(shown) : esc(data.soldOutLabel)) + '</span>' + (off > 0 ? '<s>' + money(cmp) + '</s>' : '')
    };
  }
  function renderTc3(shown) {
    var sel = shown.indexOf(state.base) > -1 ? state.base : shown[0];
    var P = tc3Parts(sel), img = typeImg(sel), lid = typesEl.getAttribute('data-tc3-id') || '';
    var html = '<div class="u-tc3-sel' + typeCls(sel) + '"><span class="u-tc3-ph">' + (img ? '<img src="' + esc(sized(img, 240)) + '" alt="" width="50" height="74">' : '') + '</span>' +
      '<span class="u-tc3-t">' + P.lab + '<span class="u-tc3-name">' + esc(sel) + '</span>' + P.meta + '</span><span class="u-tc3-pr">' + P.price + '</span></div>';
    if (shown.length > 1) {
      html += '<button type="button" class="u-tc3-bar" data-tc3-bar aria-expanded="' + tc3Open + '"' + (lid ? ' aria-controls="' + esc(lid) + '"' : '') + '><span class="u-tc3-bt"><b>' +
        esc(tc3Open ? T('up.pdp.tc3_open_title') : T('up.pdp.tc3_other')) + '</b><small>' + esc(tc3Open ? T('up.pdp.tc3_open_sub') : T('up.pdp.tc3_count', { n: shown.length, names: shown.join(' · ') })) + '</small></span>' +
        '<span class="u-tc3-chev" aria-hidden="true"><svg viewBox="0 0 16 16"><path d="M4 6l4 4 4-4"></path></svg></span></button>' +
        '<div class="u-tc3-list"' + (lid ? ' id="' + esc(lid) + '"' : '') + ' data-tc3-list' + (tc3Open ? '' : ' hidden') + '>' + shown.map(function (base) {
          var on = base === state.base, Q = tc3Parts(base), im = typeImg(base);
          return '<button type="button" class="pr-type u-tc3-row' + typeCls(base) + (on ? ' is-active' : '') + '" data-t="' + esc(base) + '" aria-pressed="' + on + '">' +
            '<span class="u-tc3-ph">' + (im ? '<img src="' + esc(sized(im, 200)) + '" alt="" width="44" height="66">' : '') + '</span>' +
            '<span class="u-tc3-t">' + Q.lab + '<b class="pr-type__name u-tc3-name">' + esc(dispT(base)) + '</b>' + Q.meta + Q.ben + '</span>' +
            '<span class="u-tc3-pr">' + (on ? '<span class="u-tc3-ok">' + esc(T('up.pdp.selected')) + '</span>' : '') + Q.price + '</span></button>';
        }).join('') + '</div>';
    }
    typesEl.innerHTML = html;
    typesEl.classList.toggle('is-open', tc3Open);
    typesEl.classList.toggle('u-tc3-full', sel === 'Full-Shock');
    typesEl.classList.toggle('u-tc3-pro', sel === 'Pro-Shock');
  }
  function tc3FocusBar() {
    var b = typesEl && typesEl.querySelector('[data-tc3-bar]');
    if (b) { try { b.focus({ preventScroll: true }); } catch (eF) { b.focus(); } }
  }

  function renderTypes() {
    if (!hasTypes || !typesEl) { return; }
    var fk = focusKey(typesEl, 'data-t');
    var anyStock = BASE_ORDER.some(baseHasStock);
    var shown = BASE_ORDER.filter(function (b) { return !anyStock || baseHasStock(b); });
    typesEl.style.setProperty('--u-tn', String(shown.length));
    if (TC3) { renderTc3(shown); if (tc3Open) { refocus(typesEl, 'data-t', fk); } return; }
    typesEl.innerHTML = shown.map(function (base, i) {
      var on = base === state.base;
      if (TC2) { return tc2Card(base, on, typeImg(base)); }
      var rec = (i === 0 && shown.length > 1 && base === 'Full-Shock') ? '<span class="u-rec">' + esc(T('up.pdp.recommended')) + '</span>' : '';
      var m = meterTxt(base), fin = finOf(base);
      var price = baseHasStock(base) ? money(groupMinPrice(base)) : esc(data.soldOutLabel);
      var img = typeImg(base);
      return '<button type="button" class="u-type' + typeCls(base) + ' pr-type' + (on ? ' is-active' : '') + '" data-t="' + esc(base) + '" aria-pressed="' + on + '">' + rec +
        '<span class="u-thumb">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" width="52" height="78">' : '') + '</span>' +
        '<b class="pr-type__name">' + esc(dispT(base)) + '</b>' + (m ? '<small>' + (data.meterLabel ? esc(data.meterLabel) + ' ' : '') + m + ' m' + (fin ? ' · ' + esc(fin) : '') + '</small>' : '') +
        '<span class="u-tp">' + price + '</span></button>';
    }).join('');
    refocus(typesEl, 'data-t', fk);
  }

  function renderMagsafe() {
    if (!msBtn) { return; }
    var g = groups[state.base] || { standard: [], magsafe: [] };
    msBtn.hidden = !g.magsafe.length;
    if (!g.magsafe.length) { return; }
    var stdPool = availOf(g.standard), msPool = availOf(g.magsafe);
    var stdMin = null, msMin = null;
    stdPool.forEach(function (v) { if (stdMin === null || v.price < stdMin) { stdMin = v.price; } });
    msPool.forEach(function (v) { if (msMin === null || v.price < msMin) { msMin = v.price; } });
    var delta = (stdMin !== null && msMin !== null)
      ? (ptOwnsFrame() ? shownPrice(state.base, msMin) - shownPrice(state.base, stdMin) : msMin - stdMin) : 0;
    var msOut = !msPool.length, stdOut = !stdPool.length;
    /* one side sold out: the toggle is locked to the side that can ship */
    msBtn.disabled = msOut !== stdOut;
    msBtn.setAttribute('aria-pressed', state.magsafe ? 'true' : 'false');
    var inc = msBtn.disabled && state.magsafe;
    var b = msBtn.querySelector('b'), note = msBtn.querySelector('[data-upd-ms-note]');
    if (b) { b.textContent = inc ? (data.msIncluded || 'MagSafe') : 'MagSafe'; }
    if (note) { note.textContent = inc ? '' : (msOut && !stdOut ? data.soldOutLabel : (delta > 0 ? '+' + money(delta) : '')); }
    msBtn.classList.toggle('u-upd-ms-out', msOut && !stdOut);
  }

  function renderSwatches() {
    if (!swEl || colorIndex < 0) { return; }
    var pool = currentPool();
    var seen = [], avail = [];
    pool.forEach(function (v) {
      var c = optVal(v, colorIndex);
      if (!c) { return; }
      if (seen.indexOf(c) === -1) { seen.push(c); }
      if (v.available && avail.indexOf(c) === -1) { avail.push(c); }
    });
    if (!state.color || avail.indexOf(state.color) === -1) { state.color = avail[0] || null; }
    var fk = focusKey(swEl, 'data-color');
    /* THE CAMERA RING (owner 2026-10-25, the mockup's .ringopt): a glossy pair's glossy case comes as "... Painted" (the
       ring's logo painted white) and "... Unpainted" (tone on tone) - two compact cards, a crop of the ring with its logo
       from the variant's own picture on the left, instead of colour dots. Same buttons (.pr-sw, data-color), same click. */
    var ringMode = !!(GMD && data.ring && avail.length > 1 && avail.every(function (c) { return /painted/i.test(c); }));
    var ringTxt = function (c) { return /unpainted/i.test(c) ? [data.ring.u, data.ring.un] : [data.ring.p, data.ring.pn]; };
    swEl.classList.toggle('u-rings', ringMode);
    if (ringMode) {
      swEl.innerHTML = avail.map(function (c) {
        var on = c === state.color, t = ringTxt(c), img = '';
        pool.forEach(function (v) { if (!img && optVal(v, colorIndex) === c && v.featured_image && v.featured_image.src) { img = sized(v.featured_image.src, 500); } });
        return '<button type="button" class="u-ringopt pr-sw' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-color="' + esc(c) + '">' +
          '<span class="u-ri"' + (img ? ' style="background-image:url(' + esc(img) + ')"' : '') + '></span><span><b>' + esc(t[0]) + '</b><small>' + esc(t[1]) + '</small></span></button>';
      }).join('');
    } else {
      swEl.innerHTML = avail.map(function (c) {
        var on = c === state.color;
        return '<button type="button" class="u-col pr-sw' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-color="' + esc(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '" style="background:' + esc(swatchMap[c.toLowerCase()] || '#cccccc') + '"></button>';
      }).join('');
    }
    refocus(swEl, 'data-color', fk);
    var clb = $('[data-upd-collbl]');
    if (clb) {
      if (!clb.hasAttribute('data-def')) { clb.setAttribute('data-def', clb.textContent); }
      clb.textContent = ringMode ? data.ring.label : clb.getAttribute('data-def');
    }
    var nm = $('[data-upd-colname]');
    /* a glossy colour reads 'Full-Shock Glossy - Metal Black Painted': the part after the finish name (owner 2026-10-25) */
    if (nm) { nm.textContent = ringMode ? ringTxt(state.color || '')[0] : String(state.color || '').replace(/^.*glossy\s*-\s*/i, ''); }
    /* a glossy pair whose type offers only the glossy variant's 'Glass': no colour to choose, no row */
    if (colRow) { colRow.hidden = !seen.length || !!(data.gm && seen.length === 1 && /^glass$/i.test(seen[0])); }
  }

  function glassPicks() { return $$('[data-pr-up][aria-pressed="true"]'); }
  function glassTotal() { return glassPicks().reduce(function (a, u) { return a + (parseInt(u.getAttribute('data-face'), 10) || 0); }, 0); }

  var lastV = null;
  function paint(v) {
    var shown = shownPrice(state.base, v.price);
    var cmp = v.available ? compareFor(v, shown) : 0;
    var pEl = $('[data-upd-price]'), sEl = $('[data-upd-compare]'), oEl = $('[data-upd-off]');
    if (pEl) { pEl.textContent = money(shown); }
    if (sEl) { sEl.hidden = !cmp; sEl.textContent = cmp ? money(cmp) : ''; }
    if (oEl) { oEl.hidden = !cmp; oEl.textContent = cmp ? '−' + Math.round((1 - shown / cmp) * 100) + '%' : ''; }
    var tn = hasTypes ? dispT(String(v.option1 || '').replace(' Transparent', '')) : '';
    var line = $('[data-upd-line]');
    if (line) { line.textContent = [tn, data.device].filter(Boolean).join(' · '); }
    var fin = hasTypes ? finOf(state.base) : '';
    var tl = $('[data-upd-typelbl]');
    if (tl) { tl.textContent = tn + (fin ? ' · ' + capFirst(fin) : ''); }
    var fp = $('[data-upd-fin]');
    if (fp) { fp.textContent = fin; fp.hidden = !fin; }
    var sbl = $('[data-upd-sbline]');
    /* the sticky bar's line stays short (owner 2026-10-25): the type and its finish on a glossy pair's glossy case (its
       colour values are long finish names), else the type and the colour; a colour over 18 characters is left out */
    if (sbl) {
      var sbc = (GMD && v._gm === 'g') ? capFirst(fin) : (String(state.color || '').length <= 18 ? state.color : '');
      sbl.textContent = [tn, sbc].filter(Boolean).join(' · ');
      /* Black Friday mode (owner 2026-11-03): the price in the type's place - the original struck and the -NN%, or the
         price itself where there is no original */
      if (W.__upBF === 1) { bfLine(sbl, shown, cmp); }
    }
    /* the add button carries the case and the ticked screen protectors at their -30% face (the mockup's total) */
    var label = v.available ? (data.ctaLabel + ' · ' + money(shown + glassTotal())) : data.soldOutLabel;
    cta.disabled = !v.available;
    cta.setAttribute('data-variant-id', String(v.id));
    if (addLbl) { addLbl.textContent = label; }
    if (fCta) {
      fCta.disabled = !v.available;
      fCta.setAttribute('data-variant-id', String(v.id));
      var fl = fCta.querySelector('[data-upd-sblbl]');
      if (fl) { fl.textContent = label; }
    }
    /* the gallery: the first slide is the chosen variant's own picture; the plate is the type's drop height */
    if (mainImg && v.featured_image && v.featured_image.src) {
      var want = sized(v.featured_image.src, 1100);
      if (mainImg.getAttribute('src') !== want) {
        mainImg.removeAttribute('srcset');
        mainImg.setAttribute('src', want);
        mainImg.alt = (root.querySelector('h1') || {}).textContent + ' ' + tn;
      }
    }
    /* glossy pair: the glossy type shows "Vezi luciul" and its clip - no sheen or other effect (owner 2026-10-24) */
    if (GMD) {
      var isG = v._gm === 'g';
      var vj = $('[data-upd-vjump]'), gvid = $('[data-upd-glossvid]');
      if (vj) { vj.hidden = !isG; }
      if (gvid) {
        gvid.hidden = !isG;
        if (!isG) { var gvv = gvid.querySelector('video'); if (gvv) { try { gvv.pause(); } catch (eGv) {} } }
      }
      /* owner 2026-10-31: the glossy type's five studio renders (snippets/mf-glossy-media) come and go with it */
      $$('[data-upd-glossset]').forEach(function (el) { el.hidden = !isG; });
      /* owner 2026-10-25: the glossy type shows no matt case - the gallery's matt hand clip (the manifest's mfg:vidhand)
         steps out, and the life band's hand clip is the glossy one (data-upd-gm g / m) */
      $$('[data-mfg="mfg:vidhand"]').forEach(function (el) {
        el.hidden = isG;
        if (isG) { var hv = el.querySelector('video'); if (hv) { try { hv.pause(); } catch (eHv) {} } }
      });
      /* the life band sits outside the gallery's root, so the whole document */
      [].slice.call(document.querySelectorAll('[data-upd-gm]')).forEach(function (el) {
        var on = (el.getAttribute('data-upd-gm') === 'g') === isG;
        el.hidden = !on;
        if (!on) { var lv = el.querySelector('video'); if (lv) { try { lv.pause(); } catch (eLv) {} } }
      });
    }
    if (plate && hasTypes) {
      var m = meterTxt(state.base), pt = (data.plates || {})[state.base] || '';
      plate.hidden = !m;
      plate.className = 'u-spec-plate' + typeCls(state.base) + ' pr-media__slide';
      var pv = plate.querySelector('[data-upd-plate-v]'), ptx = plate.querySelector('[data-upd-plate-t]');
      if (pv) { pv.textContent = m ? m + 'M' : ''; }
      if (ptx) { ptx.textContent = pt; }
    }
  }

  /* the EU 30-day lowest-price notice (snippets/30-day-price, Theme settings > 30-Day Price Block; absent = no-op)
     follows the chosen variant, as on the Hungarian product-rhode. It prices from the catalogue price as its Liquid
     does: _ap is the admin price where the cart transform's charge (gpx) replaced v.price above. */
  function thirtyDay(v) {
    if (!W.updatePriceBlock) { return; }
    W.updatePriceBlock(v._ap ? { id: v.id, price: v._ap, compare_at_price: v.compare_at_price } : v);
  }

  /* THE TYPE LINES (sections/up-product.liquid data-upd-tl): the chosen type's block shows; on the V3 selector it moves
     into the chosen card (which renderTypes rebuilds, so it is put back after every repaint), elsewhere it stays home */
  var tlEls = $$('[data-upd-tl]'), tlHome = $('[data-upd-tls]');
  function tlApply() {
    if (!tlEls.length || !tlHome) { return; }
    var selCard = typesEl ? typesEl.querySelector('.u-tc3-sel') : null;
    tlEls.forEach(function (el) {
      var on = el.getAttribute('data-upd-tl') === state.base;
      el.hidden = !on;
      var home = (on && selCard) ? selCard : tlHome;
      if (el.parentNode !== home) { home.appendChild(el); }
      if (!on) { var tv = el.querySelector('video'); if (tv) { try { tv.pause(); } catch (eT) {} } }
    });
  }

  function update() {
    syncMagsafe();
    renderSwatches();
    renderTypes();
    tlApply();
    renderMagsafe();
    var v = resolve();
    if (!v) { return; }
    lastV = v;
    paint(v);
    thirtyDay(v);
    galCount();
    floatApply();
  }

  /* ── selection ── */
  if (typesEl) {
    typesEl.addEventListener('click', function (ev) {
      var b = ev.target.closest('.pr-type');
      if (!b) { return; }
      var base = b.getAttribute('data-t');
      if (base === state.base) { return; }
      state.base = base; state.magsafe = false; state.color = null;
      update();
      /* live C's type-switch keys: what the shopper switched to (':to_' rides mf-track's send priority into the add /
         checkout joins) and a return to the opening type; mf-track books mf_pdp_option_change from this trusted click */
      var ts = slugOf(base);
      step1('pdpc:chg_' + K);
      tcOnce('tct:' + TCA);
      step1('pdpc:t:to_' + K + '_' + ts);
      if (ts === DEF) { step1('pdpc:t_back'); }
      /* a type switch lands on the first slide - the type's own picture (product-rhode, 2026-09-06) */
      if (gal) { try { gal.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (eJ) { gal.scrollLeft = 0; } }
    });
  }
  /* V3: the opener bar toggles the rows; choosing a row (or the one already chosen) closes them and returns the focus
     to the bar; Escape closes them too */
  if (typesEl && TC3) {
    typesEl.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-tc3-bar]')) { tc3Open = !tc3Open; if (tc3Open) { tcOnce('tco:' + TCA); } renderTypes(); tlApply(); tc3FocusBar(); return; }
      if (tc3Open && ev.target.closest('.pr-type')) { tc3Open = false; renderTypes(); tlApply(); tc3FocusBar(); }
    });
    typesEl.addEventListener('keydown', function (ev) {
      if (tc3Open && (ev.key === 'Escape' || ev.key === 'Esc')) { tc3Open = false; renderTypes(); tc3FocusBar(); }
    });
  }
  if (msBtn) {
    msBtn.addEventListener('click', function () {
      if (msBtn.disabled) { return; }
      state.magsafe = !state.magsafe;
      state.color = null;
      update();
      if (state.magsafe) { step1('pdpc:ms_on'); }
    });
  }
  if (swEl) {
    swEl.addEventListener('click', function (ev) {
      var b = ev.target.closest('.pr-sw');
      if (!b) { return; }
      state.color = b.getAttribute('data-color');
      update();
      if (gal && gal.scrollLeft > 0) { try { gal.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (eK) { gal.scrollLeft = 0; } }
    });
  }

  /* glossy pair: "Vezi luciul" scrolls the gallery to the clip and plays it (the mockup's vJump) */
  var vjBtn = $('[data-upd-vjump]');
  if (vjBtn && GMD) {
    vjBtn.addEventListener('click', function () {
      var gv = $('[data-upd-glossvid]');
      if (!gv || gv.hidden || !gal) { return; }
      /* the phone gallery is a horizontal swipe row: scroll it to the clip; the desktop gallery is a grid: bring the
         clip's tile into the window instead */
      if (gal.scrollWidth > gal.clientWidth + 4) {
        try { gal.scrollTo({ left: gv.offsetLeft - gal.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); } catch (eV) { gal.scrollLeft = gv.offsetLeft - gal.offsetLeft; }
      } else {
        try { gv.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (eW) { gv.scrollIntoView(); }
      }
      var vid = gv.querySelector('video');
      if (vid) { try { vid.preload = 'auto'; var pp = vid.play(); if (pp && pp.catch) { pp.catch(function () {}); } } catch (eP) {} }
      step1('pdpc:gloss_vid');
    });
  }
  /* the premium lines' "see it on video" (owner 2026-10-25): on a phone the gallery sits above, so the page goes up to it
     first; then the gallery pill's own jump (scroll to the glossy clip, play) */
  /* delegated: the V4 card's jump is a span inside the card, repainted with every type change */
  if (vjBtn && GMD) {
    D.addEventListener('click', function (ev) {
      var j = ev.target && ev.target.closest ? ev.target.closest('[data-upd-vjump2]') : null;
      /* no contains() test: choosing the V4 card repaints the row before this listener runs, so the span is detached */
      if (!j) { return; }
      var root0 = $('[data-pr-media-root]') || gal;
      if (gal && gal.scrollWidth > gal.clientWidth + 4 && root0) {
        /* instant: a smooth page scroll running together with the gallery's smooth scroll is not reliable everywhere */
        W.scrollTo(0, Math.max(0, root0.getBoundingClientRect().top + W.pageYOffset - 70));
      }
      /* a tap inside the V4 glossy card also chose that card: the clip shows only once the glossy type is painted */
      setTimeout(function () { vjBtn.click(); }, 0);
      step1('pdpc:gloss_vid2');
    });
  }

  /* the 2+2 / 1+1 strip follows the cart (owner 2026-10-25): every cart change counts the cases again - paid lines that
     are not a screen protector or the gift, the Liquid's all-cases + original_price > 0 as near as the cart JSON allows */
  var p22El = $('.u-p22');
  function p22Paint(cart) {
    if (!p22El || !cart || !cart.items) { return; }
    var segs = p22El.querySelectorAll('.u-p22-seg'), cnt = p22El.querySelector('.u-p22-count'), n = segs.length, have = 0;
    cart.items.forEach(function (it) {
      var h = String(it.handle || '');
      if (it.original_price > 0 && !/nano-glass|nanoglass|pro-shield|^bundle-|mystery/i.test(h)) { have += it.quantity; }
    });
    var fill = Math.min(have, n);
    for (var k = 0; k < n; k++) { segs[k].classList.toggle('is-on', k < fill); }
    if (cnt) { cnt.textContent = fill + '/' + n; }
    /* the line with that many cases in (data-s1..data-sN from the Liquid), else the offer line (data-s0) */
    var tx = p22El.querySelector('.u-p22-text'), ln = p22El.getAttribute('data-s' + fill) || p22El.getAttribute('data-s0');
    if (tx && ln && tx.textContent !== ln) { tx.textContent = ln; }
  }
  if (p22El) {
    var p22T = 0;
    var p22Ask = function () { clearTimeout(p22T); p22T = setTimeout(function () { W.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(p22Paint).catch(function () {}); }, 250); };
    D.documentElement.addEventListener('cart:updated', function (e) { var c = e.detail && e.detail.cart; if (c && c.items) { p22Paint(c); } else { p22Ask(); } });
    D.documentElement.addEventListener('cart:refresh', function (e) { var c = e.detail && e.detail.cart; if (c && c.items) { p22Paint(c); } else { p22Ask(); } });
    W.addEventListener('pageshow', function (e) { if (e.persisted) { p22Ask(); } });
  }

  /* the two-case offer A/B strips (snippets/mf-ofr-bar, RO): the same case count as the 1+1 strip above, on every cart
     change; ofrp:<arm> = the arm's product-page sessions, ofr2:<arm> = sessions whose cart reached two cases here */
  var ofrEls = $$('[data-ofr]'), ofrO = W.__mfOfr || {};
  var ofrArm = (/^(nsxf?|ns)$/.test(ofrO.test || '') && /^[nsxf]$/.test(ofrO.arm || '')) ? ofrO.arm : '';
  function ofrOnce(n) {
    if (!ofrArm || !W.mfTrackPush) { return; }
    try { if (sessionStorage.getItem('mf_ofro_' + n)) { return; } sessionStorage.setItem('mf_ofro_' + n, '1'); } catch (eS) { if (sentK[n]) { return; } sentK[n] = 1; }
    step(n);
  }
  function ofrPaint(cart) {
    if (!cart || !cart.items) { return; }
    var have = 0;
    cart.items.forEach(function (it) {
      var h = String(it.handle || '');
      if (it.original_price > 0 && !/nano-glass|nanoglass|pro-shield|^bundle-|mystery/i.test(h)) { have += it.quantity; }
    });
    var fill = Math.min(have, 2);
    if (fill >= 2) { ofrOnce('ofr2:' + ofrArm); }
    ofrEls.forEach(function (el) {
      var segs = el.querySelectorAll('.u-ofr-seg'), cnt = el.querySelector('.u-ofr-count'), tx = el.querySelector('.u-ofr-text');
      for (var k = 0; k < segs.length; k++) { segs[k].classList.toggle('is-on', k < fill); }
      if (cnt) { cnt.textContent = fill + '/2'; }
      el.classList.toggle('is-done', fill >= 2);
      var ln = el.getAttribute('data-s' + fill);
      if (tx && ln && tx.textContent !== ln) { tx.textContent = ln; }
    });
  }
  if (ofrArm) {
    var ofrT = 0;
    var ofrAsk = function () { clearTimeout(ofrT); ofrT = setTimeout(function () { W.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(ofrPaint).catch(function () {}); }, 250); };
    D.documentElement.addEventListener('cart:updated', function (e) { var c = e.detail && e.detail.cart; if (c && c.items) { ofrPaint(c); } else { ofrAsk(); } });
    D.documentElement.addEventListener('cart:refresh', function (e) { var c = e.detail && e.detail.cart; if (c && c.items) { ofrPaint(c); } else { ofrAsk(); } });
    W.addEventListener('pageshow', function (e) { if (e.persisted) { ofrAsk(); } });
  }

  /* ── screen protectors: chosen here, bought with the case in one add ── */
  $$('[data-pr-up]').forEach(function (u) {
    u.setAttribute('aria-pressed', 'false');
    u.addEventListener('click', function () {
      var on = u.getAttribute('aria-pressed') !== 'true';
      u.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (lastV) { paint(lastV); }
      var nm = u.querySelector('.pr-up__name');
      var nmTxt = nm ? String(nm.textContent || '').trim() : '';
      /* the live series: the old step, its v2 twin, and the flat nav-step the beacon joins on */
      push('mf_pdp_step', { mf_step: on ? 'upsell_select' : 'upsell_deselect', mf_option_value: nmTxt });
      push('mf_pdp_step', { mf_step: on ? 'upsell_select_v2' : 'upsell_deselect_v2', mf_option_value: nmTxt });
      var k = u.getAttribute('data-pr-up-kind');
      if (on && (k === 'ps' || k === 'ng')) { step('ups:' + k + '_pick'); step1('pdpc:fol_' + k); }
    });
  });
  function upsellNames() {
    return glassPicks().map(function (u) { var el = u.querySelector('.pr-up__name'); return el ? String(el.textContent || '').trim() : ''; }).filter(Boolean);
  }

  /* ── gallery: dots, the 1/N pill (tap = next slide, gone after the first real swipe), clips that play on screen ── */
  var dotsEl = $('[data-upd-dots]'), hint = $('[data-upd-hint]'), countEl = $('[data-upd-count]');
  function slides() { return gal ? [].slice.call(gal.children).filter(function (el) { return !el.hidden; }) : []; }
  var dotSig = '';
  function galCount() {
    var list = slides(), n = list.length;
    /* desktop shows the mockup's five tiles (one large, two pairs); the rest stay in the phone's swipe row. A clip
       whose only poster is Shopify's preview frame (data-upd-weak) takes a tile only when nothing else fills it */
    [].forEach.call(gal ? gal.children : [], function (el) { el.classList.remove('u-upd-xs'); });
    var tiles = list.filter(function (el) { return !el.hasAttribute('data-upd-weak'); }).slice(0, 5);
    list.forEach(function (el) { if (tiles.length < 5 && tiles.indexOf(el) === -1 && el.hasAttribute('data-upd-weak')) { tiles.push(el); } });
    list.forEach(function (el) { if (tiles.indexOf(el) === -1) { el.classList.add('u-upd-xs'); } });
    if (countEl) { countEl.textContent = '1/' + n; }
    if (hint) { hint.hidden = n < 2; }
    if (!dotsEl) { return; }
    if (String(n) !== dotSig) { dotSig = String(n); dotsEl.innerHTML = n > 1 ? new Array(n + 1).join('<i></i>') : ''; }
    galActive();
  }
  function galActive() {
    if (!dotsEl || !gal) { return; }
    var list = slides(), best = 0, bestD = Infinity, gl = gal.getBoundingClientRect().left;
    list.forEach(function (sl, i) { var d = Math.abs(sl.getBoundingClientRect().left - gl); if (d < bestD) { bestD = d; best = i; } });
    [].forEach.call(dotsEl.children, function (x, i) { x.classList.toggle('u-on', i === best); });
  }
  if (gal) {
    var touched = false, gT = 0;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evn) { gal.addEventListener(evn, function () { touched = true; }, { passive: true }); });
    gal.addEventListener('scroll', function () {
      if (touched && gal.scrollLeft > 20 && hint) { hint.classList.add('u-gone'); }
      clearTimeout(gT); gT = setTimeout(galActive, 60);
    }, { passive: true });
    if (hint) {
      hint.addEventListener('click', function () {
        var first = slides()[0];
        var w = first ? first.getBoundingClientRect().width + 10 : gal.clientWidth;
        try { gal.scrollBy({ left: w, behavior: reduce ? 'auto' : 'smooth' }); } catch (e1) { gal.scrollLeft += w; }
        hint.classList.add('u-gone');
      });
    }
    /* the manifest's clips carry data-poster (a real poster is fetched eagerly): set when the set is on the page */
    $$('video[data-poster]', gal).forEach(function (v) { v.setAttribute('poster', v.getAttribute('data-poster')); v.removeAttribute('data-poster'); });
    var gv = $$('video', gal);
    if (gv.length && !reduce && 'IntersectionObserver' in W) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var v = en.target;
          if (v.hasAttribute('data-mgm-manual')) { if (en.intersectionRatio < 0.6 && !v.paused) { v.pause(); } return; }
          if (en.intersectionRatio >= 0.6) { if (v.preload === 'none') { v.preload = 'auto'; } var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: [0, 0.6] });
      gv.forEach(function (v) { v.muted = true; vio.observe(v); });
    }
    /* owner 2026-10-31, the glossy media (snippets/mf-glossy-media): the design's 2D picture stands over the clip until
       the clip really plays (then it fades out). No autoplay - reduced motion, data saver, iPhone Low Power Mode or a
       clip that is still not playing 2.5 s after it came into view - keeps the picture and shows a play button; a tap
       plays it (a tap is allowed even in Low Power Mode). "Nézd meg, hogy néz ki" on the clip goes to the 2D picture. */
    $$('video[data-mgm]', gal).forEach(function (v) {
      var fig = v.closest('figure'), btn = fig && fig.querySelector('[data-mgm-play]');
      if (!fig) { return; }
      var conn = W.navigator && W.navigator.connection;
      var manual = reduce || !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
      if (manual) { v.setAttribute('data-mgm-manual', ''); }
      var showBtn = function () { if (btn && v.paused) { btn.hidden = false; } };
      v.addEventListener('playing', function () { fig.classList.add('mgm-on'); if (btn) { btn.hidden = true; } });
      if (btn) {
        btn.addEventListener('click', function () {
          v.removeAttribute('data-mgm-manual'); v.preload = 'auto';
          try { var pp = v.play(); if (pp && pp.catch) { pp.catch(function () {}); } } catch (eM) {}
          step1('pdpc:mgm_play');
        });
      }
      if ('IntersectionObserver' in W) {
        var mt = 0;
        new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            clearTimeout(mt);
            if (en.intersectionRatio < 0.6 || fig.hidden) { return; }
            if (manual) { showBtn(); } else { mt = setTimeout(showBtn, 2500); }
          });
        }, { threshold: [0, 0.6] }).observe(fig);
      } else { showBtn(); }
      var tog = fig.querySelector('[data-mgm-graphic]');
      if (tog) {
        tog.addEventListener('click', function () {
          var shot = gal.querySelector('[data-upd-k="r3d"]');
          if (!shot) { return; }
          if (gal.scrollWidth > gal.clientWidth + 4) {
            try { gal.scrollTo({ left: shot.offsetLeft - gal.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); } catch (eT) { gal.scrollLeft = shot.offsetLeft - gal.offsetLeft; }
          } else {
            try { shot.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (eU) { shot.scrollIntoView(); }
          }
          step1('pdpc:mgm_graphic');
        });
      }
    });
  }

  /* ── the floating add bar: only after the visitor scrolled past the real button ── */
  /* phone only: from 1024px up-sections.css hides the bar, and an invisible bar must not read as shown - mf-track's
     float_impression and mf-popup-game's launcher check (.pr-float.is-visible) both key on it; live C strips it on
     desktop the same way */
  var mqBar = W.matchMedia ? W.matchMedia('(max-width: 1023px)') : null;
  function floatApply() {
    if (!fBar) { return; }
    var r = cta.getBoundingClientRect();
    /* owner 2026-10-25: the bar shows from the first paint and steps out only while the inline button is on screen */
    var vh = W.innerHeight || D.documentElement.clientHeight;
    var show = !(r.bottom > 0 && r.top < vh) && !cta.disabled && (!mqBar || mqBar.matches);
    fBar.classList.toggle('u-on', show);
    fBar.classList.toggle('is-visible', show);
    fBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  if (fBar) {
    if ('IntersectionObserver' in W) { new IntersectionObserver(floatApply, { threshold: 0 }).observe(cta); }
    W.addEventListener('scroll', floatApply, { passive: true });
    W.addEventListener('resize', floatApply);
    if (mqBar) { try { mqBar.addEventListener('change', floatApply); } catch (eQ) { if (mqBar.addListener) { mqBar.addListener(floatApply); } } }
  }
  if (fCta) { fCta.addEventListener('click', function () { if (!fCta.disabled) { cta.click(); } }); }

  /* ── the phone: a sheet over the hidden select (the select stays the source of truth and the hook mf-track /
     mf-device.js listen on); a pick navigates to that phone's product, carrying ?view= when there is one ── */
  var devSel = $('select[data-pr-device]');
  if (devSel) {
    devSel.addEventListener('change', function () {
      if (!devSel.value || devSel.value === data.handle) { return; }
      var view = '';
      try { var vq = new URLSearchParams(W.location.search).get('view'); if (vq) { view = '?view=' + encodeURIComponent(vq); } } catch (eV) {}
      /* mfHref: the store's market prefix (routes.root_url), a no-op where there is none */
      var to = '/products/' + devSel.value + view;
      W.location.href = W.mfHref ? W.mfHref(to) : to;
    });
    /* the rows: the metafield's pairs (option text = its label, data-label = the mockup's spelling). The metafield
       lists each brand oldest first, with this phone pinned on top; the sheet lists newest first with this phone in
       its own place, in the order of the device menu sheet (#devices, snippets/up-devices - the menu's order, the
       mockup's), matched on the same folded name (its data-fold), then on a looser one ('11Pro 4G/5G' = '11 Pro',
       'S23 Plus' = 'S23+', 'Mi 11 Lite (2021)' = 'Mi 11 Lite'). A phone the menu does not list goes next to its
       nearest metafield neighbour of the same series (Galaxy A beside Galaxy A); without the menu sheet, each brand
       is the metafield reversed. */
    var items = [], pos = 0, seen = {};
    $$('optgroup', devSel).forEach(function (og) {
      $$('option', og).forEach(function (o) {
        var full = String(o.textContent || '').trim(), br = og.label;
        var lab = String(o.getAttribute('data-label') || '').trim();
        if (!lab) {
          lab = full;
          if (full.indexOf(br + ' ') === 0 && /^[A-Za-z]/.test(full.slice(br.length + 1))) { lab = full.slice(br.length + 1); }
        }
        var it = { label: lab, full: full, value: o.value, brand: br, bk: String(br).toLowerCase().replace(/[^a-z0-9]+/g, '-'), pos: pos++ };
        it.pinned = it.pos === 0 && it.value === data.handle;
        items.push(it);
        seen[it.value] = (seen[it.value] || 0) + 1;
      });
    });
    /* a phone listed twice (pinned and in place) keeps its own place */
    items = items.filter(function (it) { return !(it.pinned && seen[it.value] > 1); });
    var foldL = function (t) { return String(t || '').toLowerCase().replace(/ /g, ''); };
    var loose = function (f) { return f.replace(/\([^)]*\)/g, '').replace(/plus$/, '+').replace(/(4g|5g)(\/(4g|5g))?$/, ''); };
    var family = function (f) { return f.replace(/\d.*$/, ''); };
    var menuIdx = {}, menuLoose = {};
    [].forEach.call(D.querySelectorAll('#devices .u-devlist > a[data-fold][data-b]'), function (a, n) {
      var b = a.getAttribute('data-b'), f = a.getAttribute('data-fold') || '';
      if (!b) { return; }
      (menuIdx[b] = menuIdx[b] || {})[f] = n;
      menuLoose[b] = menuLoose[b] || {};
      if (!(loose(f) in menuLoose[b])) { menuLoose[b][loose(f)] = n; }
    });
    var byBrand = {}, brandOrder = [];
    items.forEach(function (it) {
      if (!byBrand[it.bk]) { byBrand[it.bk] = []; brandOrder.push(it.bk); }
      byBrand[it.bk].push(it);
    });
    brandOrder.forEach(function (bk) {
      var list = byBrand[bk], mi = menuIdx[bk] || {}, ml = menuLoose[bk] || {};
      list.forEach(function (it) {
        var f = foldL(it.label), n = mi[f];
        if (typeof n !== 'number') { n = ml[loose(f)]; }
        it.mi = (typeof n === 'number') ? n : null;
        it.fam = family(f);
      });
      list.forEach(function (it, j) {
        if (it.mi !== null) { it.key = it.mi; return; }
        if (it.pinned) { it.key = -1; return; }
        /* the metafield runs oldest -> newest: just above its older neighbour, else just below its newer one - one of
           its own series first, then any */
        var k = null;
        [true, false].forEach(function (same) {
          var a;
          for (a = j - 1; a >= 0 && k === null; a--) { if (!list[a].pinned && list[a].mi !== null && (!same || list[a].fam === it.fam)) { k = list[a].mi - 0.5; } }
          for (a = j + 1; a < list.length && k === null; a++) { if (list[a].mi !== null && (!same || list[a].fam === it.fam)) { k = list[a].mi + 0.5; } }
        });
        it.key = k === null ? 1e6 - it.pos : k;
      });
      list.sort(function (x, y) { return (x.key - y.key) || (y.pos - x.pos); });
    });
    /* the brand tabs in the mockup's order (Apple, Samsung, Xiaomi, Huawei), any other brand after them */
    var brands = ['apple', 'samsung', 'xiaomi', 'huawei'].filter(function (b) { return !!byBrand[b]; })
      .concat(brandOrder.filter(function (b) { return ['apple', 'samsung', 'xiaomi', 'huawei'].indexOf(b) === -1; }));
    items = [];
    brands.forEach(function (b) { items = items.concat(byBrand[b]); });
    var cur = items.filter(function (it) { return it.value === devSel.value; })[0];
    var activeBrand = cur ? cur.bk : brands[0];
    var bEl = D.querySelector('[data-upd-brands]'), lEl = D.querySelector('[data-upd-devlist]'), qEl = D.querySelector('[data-upd-dq]');
    var fold = function (t) { return String(t || '').toLowerCase().replace(/\s+/g, ''); };
    /* the tabs are built once (a rebuild would reset the row's scroll and the keyboard focus): the mockup's equal
       columns, four at most - a fifth brand and on scroll in sideways, as on the device menu sheet */
    if (bEl) {
      bEl.style.setProperty('--u-bn', String(Math.min(brands.length, 4)));
      bEl.classList.toggle('u-scroll', brands.length > 4);
      bEl.innerHTML = brands.map(function (b) { return '<button type="button" aria-pressed="false" data-b="' + esc(b) + '">' + esc(byBrand[b][0].brand) + '</button>'; }).join('');
    }
    var renderDev = function () {
      if (!bEl || !lEl) { return; }
      var q = qEl ? fold(qEl.value) : '';
      bEl.hidden = !!q || brands.length < 2;
      $$('[data-b]', bEl).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-b') === activeBrand)); });
      var list = items.filter(function (it) { return q ? fold(it.full).indexOf(q) !== -1 || fold(it.label).indexOf(q) !== -1 : it.bk === activeBrand; });
      lEl.innerHTML = list.length
        ? list.map(function (it) { return '<button type="button" data-dev="' + esc(it.value) + '" aria-current="' + (it.value === devSel.value) + '">' + esc(it.label) + '</button>'; }).join('')
        : '<p class="u-lead u-upd-devnone">' + esc(T('up.pdp.dev_none', { q: qEl ? qEl.value : '' })) + '</p>';
    };
    if (bEl) { bEl.addEventListener('click', function (ev) { var b = ev.target.closest('[data-b]'); if (b) { activeBrand = b.getAttribute('data-b'); renderDev(); } }); }
    if (qEl) { qEl.addEventListener('input', function () { renderDev(); step1('pdpc:dev_q'); }); }
    if (lEl) {
      lEl.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-dev]');
        if (!b) { return; }
        var h = b.getAttribute('data-dev');
        if (h === devSel.value) { if (W.upPanel) { W.upPanel.close(); } return; }
        devSel.value = h;
        devSel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    D.addEventListener('u:panel-open', function (ev) {
      if (!ev.detail || ev.detail.id !== 'upd-dev') { return; }
      if (qEl) { qEl.value = ''; }
      activeBrand = cur ? cur.bk : brands[0];
      renderDev();
      /* the open brand's tab in view (a fifth brand sits off the row) */
      var on = bEl && bEl.querySelector('[aria-pressed="true"]');
      if (on && bEl.classList.contains('u-scroll')) { var over = on.getBoundingClientRect().right - bEl.getBoundingClientRect().right; if (over > 0) { bEl.scrollLeft += over + 3; } }
      step1('pdpc:dev_open');
    });
  }

  /* ── below the buy box ── */
  $$('details[data-upd-acc]').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { step1('pdpc:acc_' + d.getAttribute('data-upd-acc')); } });
  });
  /* the drop-test cities: an ARIA tablist (roving tabindex, arrows / Home / End move and select) */
  $$('.u-rj-tabs').forEach(function (t) {
    var tabs = $$('[data-rj]', t);
    function pick(b, focus) {
      tabs.forEach(function (x) { var on = x === b; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
      $$('[data-rjp]', t.parentElement).forEach(function (p) { p.hidden = p.getAttribute('data-rjp') !== b.getAttribute('data-rj'); if (p.hidden) { $$('video', p).forEach(function (v) { v.pause(); }); } });
      if (focus) { try { b.focus({ preventScroll: true }); } catch (eF) { b.focus(); } }
    }
    t.addEventListener('click', function (e) { var b = e.target.closest('[data-rj]'); if (b) { pick(b, false); } });
    t.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(D.activeElement), n = tabs.length;
      if (i < 0) { return; }
      var to = e.key === 'ArrowRight' ? (i + 1) % n : e.key === 'ArrowLeft' ? (i + n - 1) % n : e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : -1;
      if (to < 0) { return; }
      e.preventDefault();
      pick(tabs[to], true);
    });
  });
  /* the openers say whether their sheet is open */
  function expanded(id, on) { $$('[data-u-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  D.addEventListener('u:panel-open', function (ev) { if (ev.detail && /^upd-/.test(ev.detail.id)) { expanded(ev.detail.id, true); } });
  D.addEventListener('u:panel-close', function (ev) { if (ev.detail && /^upd-/.test(ev.detail.id)) { expanded(ev.detail.id, false); } });
  var revMore = $('[data-upd-revmore]');
  if (revMore) { revMore.addEventListener('click', function () { var r = $('[data-upd-reviews]'); if (r) { r.classList.add('u-all'); } }); }
  var rail = $('[data-upd-rail]');
  if (rail) { rail.addEventListener('click', function (e) { if (e.target.closest('a[href]')) { step1('pdpc:rail_rec'); } }, true); }
  var giftInfo = $('[data-upd-giftinfo]');
  if (giftInfo) { giftInfo.addEventListener('click', function () { step1('pdpc:gift_howto'); }); }

  /* ════════ THE ADD FLOW - product-rhode.liquid ~5168-5580 ════════ */
  var pendingSections = null;
  function openDrawer() {
    var drawer = D.querySelector('cart-drawer');
    if (drawer) { drawer.open = true; }
    return drawer;
  }
  /* open on the click, busy; theme.js replaces the drawer's innerHTML, never the element, so the class survives the
     re-render and cart-drawer:loaded clears it */
  function beginAdd() {
    var drawer = D.querySelector('cart-drawer');
    if (!drawer) { return; }
    drawer.classList.add('is-adding');
    drawer.open = true;
    clearTimeout(drawer._prBusy);
    drawer._prBusy = setTimeout(function () { drawer.classList.remove('is-adding'); }, 8000);
  }
  function endAdd(failed) {
    var drawer = D.querySelector('cart-drawer');
    if (!drawer) { return; }
    clearTimeout(drawer._prBusy);
    drawer.classList.remove('is-adding');
    if (failed) { drawer.open = false; }
  }
  D.documentElement.addEventListener('cart-drawer:loaded', function () { endAdd(false); });

  function afterAdd(addData) {
    var sections = pendingSections;
    pendingSections = null;
    /* invalidate BEFORE dispatching: the consumers the event wakes call mfCart.get() during the dispatch */
    if (W.mfCart) { W.mfCart.invalidate(); }
    var painted = !!(sections && sections['mini-cart']);
    if (painted) {
      var added = 0;
      if (addData && Array.isArray(addData.items)) { addData.items.forEach(function (line) { added += (line.quantity || 0); }); }
      var known = W.mfCart ? W.mfCart.count() : 0;
      D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: { item_count: (known || 0) + added, sections: sections } }
      }));
    }
    openDrawer();
    var load = W.mfCart ? W.mfCart.get() : fetch('/cart.js').then(function (r) { return r.json(); });
    return load.then(function (cart) {
      /* the badge's number belongs to theme.js and summer-sale-26; only the visibility class is touched here */
      if (cart.item_count > 0) {
        $$('cart-count.visually-hidden', D).forEach(function (el) { el.classList.remove('visually-hidden'); });
      }
      D.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      rkAdd();
      if (!painted) {
        D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        openDrawer();
      }
    });
  }
  function showAddError(message) {
    $$('[data-pr-cta-error]').forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
      clearTimeout(el._prTimer);
      el._prTimer = setTimeout(function () { el.hidden = true; }, 6000);
    });
  }
  function sendAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'mini-cart' })
    });
  }
  function postItems(items, quiet) {
    pendingSections = null;
    return sendAdd(items)
      .then(function (response) {
        /* 429 = Shopify rate limiting the cart API: worth exactly one retry */
        if (response.status !== 429) { return response; }
        return new Promise(function (resolve) { setTimeout(resolve, 1200); }).then(function () { return sendAdd(items); });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            /* quiet: the gift attempt - a failure there is retried without the gift, not shown */
            if (!quiet) { showAddError(response.status === 429 ? data.errBusy : ((body && body.description) || data.errGeneric)); }
            throw new Error('cart/add.js returned ' + response.status);
          });
        }
        return response.json().then(function (d) {
          if (d && d.sections) { pendingSections = d.sections; }
          return d;
        }).catch(function () { return null; });
      });
  }

  var lastCtaOrigin = 'inline';
  /* which case type went into the cart - on SUCCESS; never named add_to_cart (the native pixel owns that one) */
  function trackCaseAdd(variantId) {
    try {
      if (!W.mfTrackPush) { return; }
      var shown = state.base || '';
      var v = resolve();
      var protectors = upsellNames();
      tcOnce('tcadd:' + TCA);
      W.mfTrackPush('mf_case_add', {
        mf_case_type: shown,
        mf_real_type: (GMD && v && v._gb) ? v._gb : shown,
        mf_offered: offeredSet(),
        mf_offer_count: String(offeredSet().split('+').filter(Boolean).length),
        mf_synthetic: 'no',
        mf_magsafe: state.magsafe ? 'yes' : 'no',
        mf_color: String(state.color || ''),
        mf_device: devSel ? String(devSel.value || '') : String(data.devLast || ''),
        mf_protectors: protectors.join('+'),
        mf_protector_count: String(protectors.length),
        mf_cta_origin: lastCtaOrigin,
        mf_default_type: String(W.__mfDefault || ''),
        mf_default_kept: W.__mfDefault ? (shown === W.__mfDefault ? 'yes' : 'no') : '',
        mf_variant_id: String(variantId || ''),
        mf_item_name: String(data.itemName || ''),
        mf_price: v && v.price ? String(v.price / 100) : ''
      });
      /* the first-party copy: a plain counter on our own endpoint, fire-and-forget, nothing personal */
      var url = data.beaconUrl || '';
      if (url && navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([JSON.stringify({
          c: data.shop,
          case_type: shown,
          real_type: (GMD && v && v._gb) ? v._gb : shown,
          offered: offeredSet(),
          color: String(state.color || ''),
          device: devSel ? String(devSel.value || '') : '',
          protectors: protectors,
          magsafe: state.magsafe ? 1 : 0,
          origin: lastCtaOrigin,
          default_type: String(W.__mfDefault || ''),
          product: data.handle
        })], { type: 'text/plain' }));
      }
    } catch (e) {}
  }
  /* ONE GIFT PER ORDER: does the cart already hold a gift line? A FRESH /cart.js at tap time; a failed read says no
     (snippets/mf-gift-one.liquid trims a second gift back to one) */
  function mgCartHasGift(giftVid) {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return ((c && c.items) || []).some(function (it) { return it.variant_id === giftVid || it.sku === data.giftSku; }); })
      .catch(function () { return false; });
  }

  /* ARM A of the collection order test: the add that came from a collection grid tap (assets/up-lists.js mf_rka: the
     design and its depth band) goes to mf-beacon api/plp.js once - the score's "add" */
  function rkAdd() {
    var st = W.__mfStore || {}, u = String(st.beacon_url || ''), r = null;
    if (!/\/api\/case-add/.test(u)) { return; }
    try { r = JSON.parse(W.sessionStorage.getItem('mf_rka') || 'null'); W.sessionStorage.removeItem('mf_rka'); } catch (e) { r = null; }
    if (!r || !r.m || !r.b || r.h !== data.handle || new Date().getTime() - (r.t || 0) > 1800000) { return; }
    try { W.navigator.sendBeacon(u.replace(/\/api\/case-add.*$/, '/api/plp'), JSON.stringify({ c: String(st.beacon_c || ''), add: [r.m, r.b] })); } catch (e2) {}
  }

  cta.addEventListener('click', function (ev) {
    var variantId = parseInt(cta.getAttribute('data-variant-id'), 10);
    if (!variantId || cta.disabled || cta.getAttribute('aria-busy') === 'true') { return; }
    /* the float bar forwards its tap as a synthetic click: isTrusted tells the two surfaces apart */
    lastCtaOrigin = (ev && ev.isTrusted === false) ? 'float' : 'inline';
    cta.setAttribute('aria-busy', 'true');
    var items;
    /* the gift: arm B (everyone since 2026-10-05) always, one per order */
    var mgArm = W.__mfMG || 'a';
    var promoVariant = (data.gift && mgArm === 'b') ? parseInt(data.gift, 10) : 0;
    if (promoVariant) {
      var v = resolve();
      var caseSku = (v && v.sku) ? v.sku : String(variantId);
      /* 'Pentru husă' (this store's word: mf.up.pdp.gift_for_case) is the pairing the warehouse reads on the order
         (caseSku is the machine one); without the word only caseSku rides */
      var gProps = { caseSku: caseSku }, forCase = T('up.pdp.gift_for_case');
      if (forCase) { gProps[forCase] = String((v && v._pt) || data.title || '') + (v && v.title ? ' – ' + v.title : ''); }
      items = [
        { id: variantId, quantity: 1, properties: { caseSku: caseSku } },
        { id: promoVariant, quantity: 1, properties: gProps }
      ];
    } else {
      items = [{ id: variantId, quantity: 1 }];
    }
    /* glossy pair: the drawer names the line as the card did - snippets/up-cart.liquid swaps _mf_slim_src for _mf_slim
       in the variant title (Full-Shock / Black -> Slim-Shock / Black; the glossy line's whole title -> Full-Shock /
       Lucios). The line is the real variant; checkout and the order keep its own title. Pro-Shock carries nothing. */
    if (GMD) {
      var gmV = resolve();
      if (gmV && gmV._gb && state.base && gmV._gb !== state.base && String(gmV.id) === String(variantId)) {
        items[0].properties = Object.assign({}, items[0].properties || {}, gmV._gm === 'g' ? { _mf_slim: T('up.pdp.gloss_line_title'), _mf_slim_src: gmV.title } : { _mf_slim: state.base, _mf_slim_src: gmV._gb });
      }
    }
    /* the ticked protectors: -30% faced ones through Storefront cartLinesAdd after the AJAX add (/cart/add.js
       properties never reach the Function's input; cartLinesAdd attributes on the same cart do), plain ones ride the
       AJAX request */
    var promoUpsells = [];
    glassPicks().forEach(function (u) {
      var vid = parseInt(u.getAttribute('data-variant-id'), 10);
      if (!vid) { return; }
      if (u.getAttribute('data-pr-up-promo') === '1') { promoUpsells.push(vid); }
      else { items.push({ id: vid, quantity: 1 }); }
    });
    function addPromoLines(vids, face) {
      return fetch('/cart.js').then(function (cr) { return cr.json(); }).then(function (c) {
        return fetch('/api/2024-01/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: 'mutation($cid: ID!, $lines: [CartLineInput!]!) { cartLinesAdd(cartId: $cid, lines: $lines) { cart { id } userErrors { message } } }',
            variables: {
              cid: 'gid://shopify/Cart/' + c.token,
              lines: vids.map(function (id) {
                return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1, attributes: [{ key: 'Reducere folie', value: face }] };
              })
            }
          })
        });
      }).then(function (gr) { return gr.json(); }).then(function (d) {
        var ca = d && d.data && d.data.cartLinesAdd;
        if (!ca || (ca.userErrors && ca.userErrors.length)) { throw new Error('promo add failed'); }
      });
    }
    beginAdd();
    var upsellPicks = glassPicks()
      .map(function (u) { return { kind: u.getAttribute('data-pr-up-kind'), promo: u.getAttribute('data-pr-up-promo') === '1' }; })
      .filter(function (k) { return k.kind === 'ps' || k.kind === 'ng'; });
    var giftIn = promoVariant > 0;
    function withoutGift(list) {
      return list.filter(function (it) { return it.id !== promoVariant; }).map(function (it) {
        if (it.properties && it.properties.caseSku) {
          var props = {}; Object.keys(it.properties).forEach(function (k) { if (k !== 'caseSku') { props[k] = it.properties[k]; } });
          it = { id: it.id, quantity: it.quantity, properties: props };
        }
        return it;
      });
    }
    (giftIn ? mgCartHasGift(promoVariant) : Promise.resolve(false))
      .then(function (had) {
        if (had) { giftIn = false; items = withoutGift(items); }
        return postItems(items, giftIn);
      })
      .catch(function (e) {
        if (!giftIn) { throw e; }
        step('mgf:' + mgArm);
        return postItems(withoutGift(items));
      })
      .then(function (r) {
        trackCaseAdd(variantId);
        if (data.ptEligible === true) { step('prba:' + data.priceBand + '_' + (W.__mfPTD === 'sale' ? 'sale' : 'plain')); }
        if (upsellPicks.length) {
          var anyPromo = false;
          upsellPicks.forEach(function (k) { if (k.promo) { anyPromo = true; } step('ups:pdp_add_' + k.kind); });
          if (anyPromo) {
            try { if (W.mfMarkFol) { fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (c) { W.mfMarkFol('p30', c); }).catch(function () {}); } } catch (eM) {}
          }
        }
        if (promoUpsells.length) {
          /* one retry, then give up WITHOUT adding: a missing protector is recoverable, an unpriced promo line is not */
          return addPromoLines(promoUpsells, '-30%')
            .catch(function () { return addPromoLines(promoUpsells, '-30%'); })
            .catch(function (e2) { if (W.console) { console.error('[mf] promo upsell add failed', e2); } })
            .then(function () {
              /* the painted sections predate cartLinesAdd: drop them, afterAdd takes the full-cart path */
              pendingSections = null;
              return afterAdd(r);
            });
        }
        return afterAdd(r);
      })
      .catch(function (err) {
        if (W.console) { console.error('Add to cart error:', err); }
        endAdd(true);
        if (String(err && err.message).indexOf('cart/add.js returned') !== 0) { showAddError(data.errGeneric); }
      })
      .then(function () { cta.removeAttribute('aria-busy'); });
  });
  /* the gallery slide on screen when the button was pressed (lifestyle pages' addon_ step, below) */
  var galAddon = null;
  root.addEventListener('click', function (ev) {
    if (galAddon && ev.target && ev.target.closest && ev.target.closest('[data-pr-cta], [data-pr-float-cta]')) { galAddon(); }
  }, true);

  /* ── boot ── */
  update();
  D.documentElement.classList.remove('mf-tc-pend');
  D.addEventListener('mf:ptd-adopted', function () { try { update(); } catch (e) {} }, false);
  D.addEventListener('mf:pt-adopted', function () { try { update(); } catch (e) {} }, false);

  /* ── lifestyle gallery content steps (product-rhode's gal:b_* family; lifestyle pages only). Kinds: r3d (the
     variant's picture), plate, dropv (this face's own two slides), hero / vfull / vhand / still (the manifest). ── */
  var mroot = $('[data-pr-media-root]');
  var lifeOn = !!(mroot && mroot.hasAttribute('data-mfg-test') && gal);
  if (lifeOn) {
    var mSent = {};
    var mStep = function (name) { var k = 'gal:b_' + name; if (mSent[k]) { return; } mSent[k] = 1; step(k); };
    var kindOf = function (sl) {
      var t = sl.getAttribute('data-mfg') || '';
      if (t === 'mfg:hero') { return 'hero'; }
      if (t === 'mfg:vidfull') { return 'vfull'; }
      if (t === 'mfg:vidhand') { return 'vhand'; }
      if (t.indexOf('mfg:') === 0) { return 'still'; }
      return sl.getAttribute('data-upd-k') || (sl.querySelector('video') ? 'vold' : 'studio');
    };
    var fineOf = function (sl) { var t = sl.getAttribute('data-mfg') || ''; return /^mfg:\d+$/.test(t) ? 's' + t.slice(4) : kindOf(sl); };
    var onScreen = function () {
      var best = null, bestV = 0, sr = gal.getBoundingClientRect();
      slides().forEach(function (sl) { var r = sl.getBoundingClientRect(); var v = Math.max(0, Math.min(r.right, sr.right) - Math.max(r.left, sr.left)); if (v > bestV) { bestV = v; best = sl; } });
      return best;
    };
    galAddon = function () { var on = onScreen(); if (on) { mStep('addon_' + fineOf(on)); } };
    var all = slides();
    if ('IntersectionObserver' in W) {
      var holdT = {};
      var ioH = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          var k = fineOf(en.target);
          if (en.isIntersecting) { if (!holdT[k]) { holdT[k] = setTimeout(function () { mStep('hold_' + k); }, 2000); } }
          else if (holdT[k]) { clearTimeout(holdT[k]); holdT[k] = 0; }
          if (en.isIntersecting) { mStep('see_' + kindOf(en.target)); }
        });
      }, { root: W.innerWidth < 1024 ? gal : null, threshold: 0.6 });
      all.forEach(function (sl) { ioH.observe(sl); });
    }
    all.forEach(function (sl) {
      var v = sl.querySelector('video'); if (!v) { return; }
      var k = kindOf(sl), watched = 0, lastT = 0;
      v.addEventListener('playing', function () { mStep('play_' + k); });
      v.addEventListener('timeupdate', function () {
        var ct = v.currentTime;
        if (ct > lastT && ct - lastT < 2) { watched += ct - lastT; }
        lastT = ct;
        if (watched >= 3) { mStep('w3_' + k); }
        if (watched >= 10) { mStep('w10_' + k); }
      });
    });
    var userNav = false, swiped = false;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evn) { gal.addEventListener(evn, function () { userNav = true; }, { passive: true }); });
    gal.addEventListener('scroll', function () { if (userNav && !swiped) { swiped = true; mStep('nav_swipe'); } }, { passive: true });
    if ('IntersectionObserver' in W) {
      var acc = 0, since = 0;
      new IntersectionObserver(function (ents) {
        var vis = ents[0] && ents[0].isIntersecting, now = new Date().getTime();
        if (vis) { since = now; } else if (since) { acc += now - since; since = 0; }
        if (since && !mSent['gal:b_dwell10']) {
          setTimeout(function () { var t = acc + (since ? new Date().getTime() - since : 0); if (t >= 10000) { mStep('dwell10'); } }, 10000);
        }
      }, { threshold: 0.5 }).observe(mroot);
    }
  }

  /* the page keys, after load (mf-track is deferred: load + one retry, the live pattern) */
  var viewSent = false;
  function sendView() {
    if (viewSent || !W.mfTrackPush) { return; }
    viewSent = true;
    if (hasTypes) { W.mfTrackPush('mf_pdp_step', { mf_step: 'pdpt:' + (W.__mfPDP === 'b' ? (PDP_B ? 'b' : 'bna') : 'a') }); }
    step('pdpc:view');
    if (hasTypes) { tcOnce('tcv:' + TCA); }
    if (hasTypes) { ofrOnce('ofrp:' + ofrArm); }
    step1('pdpc:face_up');
    step1('pdpc:def_' + K + (DEF ? '_' + DEF : ''));
    var no = ($$('[data-pr-up]').length ? '' : 'f') + (data.gift ? '' : 'g');
    if (no) { step1('pdpc:no_' + no); }
    if (lifeOn) { step('gal2:b'); }
  }
  function viewLate() { setTimeout(sendView, 0); setTimeout(sendView, 1500); }
  if (D.readyState === 'complete') { viewLate(); } else { W.addEventListener('load', viewLate, false); }

  /* QA hook */
  W.__upPdp = { state: state, resolve: resolve, update: update, variants: function () { return variants; } };
})();

/* ════════ ACCESSORY MODE - the Pro-Shield, NanoGlass and AirShock pages (owner 2026-10-21) ════════
 * sections/up-product.liquid with mode 'accessory' renders snippets/up-pdp-acc-main.liquid on its own root,
 * [data-upda]: the case page's script above never sees it (it reads [data-upd] only), and the root carries no
 * [data-pr], so mf-track's case-page series (pdpc:*, mf_case_add, option changes, float, block depth) stay case-only.
 * Ported from sections/glossy-color.liquid and glossy-airshock.liquid (their live templates run with the protector
 * upsell and the promo gift off):
 *   - selectors: AirShock's model (option1, cards) and colour (option2, swatches from settings.color_swatch_config;
 *     a colour the new model lacks moves to its first colour in stock); a single-variant protector has none;
 *   - prices: the variant's own, compare_at struck unless full-price mode (settings / window.__mfFP), in the shop's
 *     money format (window.mfMoney, the same as Liquid's | money);
 *   - the add: ONE line {id, quantity: 1}, nothing riding with it (no gift - it goes with the first case only, owner
 *     2026-10-21 - no properties), through the new page's mechanics (POST /cart/add.js with sections 'mini-cart', one
 *     retry on 429, the visible error, cart:refresh with the sections, the drawer, cart:updated; variant:added not
 *     fired - the native pixel owns add_to_cart);
 *   - the measurement: glossy's first-party surface counter (mf-beacon case-add, kind item_add, surface
 *     protector_pdp / airshock), now sent only when the add succeeded (live sent it on any response).
 * The phone sheet is the case page's (#upd-dev over the hidden select[data-pr-device], which assets/mf-device.js
 * remembers the device from); here a row the device menu lists takes the menu's own spelling ('iPhone 17Pro' in a
 * NanoGlass metafield reads 'iPhone 17 Pro').
 * ES5, like the rest of this file.
 */
(function () {
  'use strict';
  var W = window, D = document;
  var root = D.querySelector('[data-upda]');
  if (!root || root.__upda) { return; }
  root.__upda = true;
  var data;
  try { data = JSON.parse(root.querySelector('[data-upda-data]').getAttribute('data-upda-data')); } catch (e0) { return; }

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(src, w) {
    if (!src) { return ''; }
    src = String(src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ── money: window.mfMoney (snippets/mf-ctl-head, the shop's format as Liquid's | money; multistore 2026-10-25) ── */
  function money(cents) { return W.mfMoney ? W.mfMoney(cents) : String((cents || 0) / 100); }
  /* the sticky bar's line in Black Friday mode: <s>original</s> -NN%, or the price */
  function bfLine(el, shown, cmp) {
    el.textContent = '';
    if (cmp > shown) {
      var s = D.createElement('s'), o = D.createElement('span');
      s.textContent = money(cmp); o.className = 'u-off'; o.textContent = '−' + Math.round((1 - shown / cmp) * 100) + '%';
      el.appendChild(s); el.appendChild(D.createTextNode(' ')); el.appendChild(o);
    } else { el.textContent = money(shown); }
  }
  function T(k, vars) { return W.mfT ? String(W.mfT(k, vars) || '') : ''; }
  var swatchMap = {};
  String(data.swatchConfig || '').split('\n').forEach(function (line) {
    var i = line.indexOf(':');
    if (i > 0) { swatchMap[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim(); }
  });

  /* ── variants and the picks ── */
  var variants = data.variants || [];
  var FP = data.fullPrice === true || W.__mfFP === true;
  if (FP) { variants.forEach(function (v) { v.compare_at_price = null; }); }
  var ci = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
  function ov(v, i) { return v.options ? v.options[i] : v['option' + (i + 1)]; }
  var v0 = variants.filter(function (v) { return v.id === data.v0; })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
  if (!v0) { return; }
  var nOpt = (v0.options || []).length;
  var pick = [];
  for (var pi = 0; pi < nOpt; pi++) { pick[pi] = ov(v0, pi); }
  /* the variants that match every pick but the colour */
  function pool() {
    return variants.filter(function (v) {
      for (var i = 0; i < nOpt; i++) { if (i !== ci && ov(v, i) !== pick[i]) { return false; } }
      return true;
    });
  }
  function resolve() {
    var p = pool(), hit = null;
    if (ci >= 0) { p.some(function (v) { if (v.available && ov(v, ci) === pick[ci]) { hit = v; return true; } return false; }); }
    if (!hit) { p.some(function (v) { if (v.available) { hit = v; return true; } return false; }); }
    if (!hit && ci >= 0) { p.some(function (v) { if (ov(v, ci) === pick[ci]) { hit = v; return true; } return false; }); }
    return hit || p[0] || null;
  }

  /* ── DOM ── */
  var cta = $('[data-upda-cta]');
  var fBar = $('[data-upda-float]');
  var fCta = $('[data-upda-float-cta]');
  var gal = $('[data-upda-gal]');
  var mainImg = $('[data-upda-main]');
  var swEl = $('[data-upda-swatches]');
  if (!cta) { return; }

  /* a re-render replaces the swatches: the keyboard focus goes back to the one with the same colour */
  function refocus(box, attr, key) {
    if (key == null || !box) { return; }
    var list = box.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute(attr) === key) { try { list[i].focus({ preventScroll: true }); } catch (eF) { list[i].focus(); } return; }
    }
  }
  /* the option cards keep their buttons (no focus loss): only their state and the label change */
  function renderOpts() {
    $$('[data-upda-opt]').forEach(function (g) {
      var i = parseInt(g.getAttribute('data-upda-opt'), 10);
      $$('[data-v]', g).forEach(function (b) {
        var on = b.getAttribute('data-v') === pick[i];
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var lb = $('[data-upda-optlbl="' + i + '"]');
      if (lb) { lb.textContent = pick[i] || ''; }
    });
  }
  function renderSwatches() {
    if (!swEl || ci < 0) { return; }
    var avail = [];
    pool().forEach(function (v) { var c = ov(v, ci); if (c && v.available && avail.indexOf(c) === -1) { avail.push(c); } });
    if (avail.indexOf(pick[ci]) === -1 && avail.length) { pick[ci] = avail[0]; }
    var a = D.activeElement, fk = (a && swEl.contains(a)) ? a.getAttribute('data-color') : null;
    swEl.innerHTML = avail.map(function (c) {
      var on = c === pick[ci];
      return '<button type="button" class="u-col' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-color="' + esc(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '" style="background:' + esc(swatchMap[String(c).toLowerCase()] || '#cccccc') + '"></button>';
    }).join('');
    refocus(swEl, 'data-color', fk);
    var nm = $('[data-upda-colname]');
    if (nm) { nm.textContent = pick[ci] || ''; }
    var row = $('[data-upda-colrow]');
    if (row) { row.hidden = !avail.length; }
  }
  function dynLine() {
    var parts = [];
    for (var i = 0; i < nOpt; i++) { if (i !== ci && $('[data-upda-opt="' + i + '"]') && pick[i]) { parts.push(pick[i]); } }
    return parts.join(' · ');
  }

  var lastV = null;
  function paint(v) {
    var cmp = (v.available && v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
    var pEl = $('[data-upda-price]'), sEl = $('[data-upda-compare]'), oEl = $('[data-upda-off]');
    if (pEl) { pEl.textContent = money(v.price); }
    if (sEl) { sEl.hidden = !cmp; sEl.textContent = cmp ? money(cmp) : ''; }
    if (oEl) { oEl.hidden = !cmp; oEl.textContent = cmp ? '−' + Math.round((1 - v.price / cmp) * 100) + '%' : ''; }
    var dyn = dynLine();
    var line = $('[data-upda-line]');
    if (line) { line.textContent = [data.line, dyn].filter(Boolean).join(' · '); }
    var sbl = $('[data-upda-sbline]');
    if (sbl) { sbl.textContent = [dyn || data.dev, ci >= 0 ? pick[ci] : ''].filter(Boolean).join(' · '); if (W.__upBF === 1) { bfLine(sbl, v.price, cmp); } }
    var label = v.available ? (data.ctaLabel + ' · ' + money(v.price)) : data.soldOutLabel;
    cta.disabled = !v.available;
    cta.setAttribute('data-variant-id', String(v.id));
    var al = $('[data-upda-addlbl]');
    if (al) { al.textContent = label; }
    if (fCta) {
      fCta.disabled = !v.available;
      fCta.setAttribute('data-variant-id', String(v.id));
      var fl = $('[data-upda-sblbl]');
      if (fl) { fl.textContent = label; }
    }
    /* the first slide is the chosen variant's own picture (glossy swapped its one image the same way) */
    if (mainImg && v.featured_image && v.featured_image.src) {
      var want = sized(v.featured_image.src, 1100);
      if (mainImg.getAttribute('src') !== want) {
        mainImg.removeAttribute('srcset');
        mainImg.setAttribute('src', want);
        var h1 = root.querySelector('h1');
        mainImg.alt = [h1 ? h1.textContent : '', dyn, ci >= 0 ? pick[ci] : ''].filter(Boolean).join(' ');
      }
    }
  }
  function update() {
    renderSwatches();
    var v = resolve();
    if (!v) { return; }
    if (ci >= 0) { pick[ci] = ov(v, ci); }
    renderOpts();
    lastV = v;
    paint(v);
    if (W.updatePriceBlock) { W.updatePriceBlock(v); }
    galCount();
    floatApply();
  }

  $$('[data-upda-opt]').forEach(function (g) {
    var i = parseInt(g.getAttribute('data-upda-opt'), 10);
    g.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-v]');
      if (!b || b.getAttribute('data-v') === pick[i]) { return; }
      pick[i] = b.getAttribute('data-v');
      update();
      if (gal && gal.scrollLeft > 0) { try { gal.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (eJ) { gal.scrollLeft = 0; } }
    });
  });
  if (swEl) {
    swEl.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-color]');
      if (!b) { return; }
      pick[ci] = b.getAttribute('data-color');
      update();
      if (gal && gal.scrollLeft > 0) { try { gal.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (eK) { gal.scrollLeft = 0; } }
    });
  }

  /* ── gallery: dots, the 1/N pill (tap = next slide), clips that play on screen ── */
  var dotsEl = $('[data-upda-dots]'), hint = $('[data-upda-hint]'), countEl = $('[data-upda-count]');
  function slides() { return gal ? [].slice.call(gal.children).filter(function (el) { return !el.hidden; }) : []; }
  var dotSig = '';
  function galActive() {
    if (!dotsEl || !gal) { return; }
    var list = slides(), best = 0, bestD = Infinity, gl = gal.getBoundingClientRect().left;
    list.forEach(function (sl, i) { var d = Math.abs(sl.getBoundingClientRect().left - gl); if (d < bestD) { bestD = d; best = i; } });
    [].forEach.call(dotsEl.children, function (x, i) { x.classList.toggle('u-on', i === best); });
  }
  function galCount() {
    var n = slides().length;
    if (countEl) { countEl.textContent = '1/' + n; }
    if (hint) { hint.hidden = n < 2; }
    if (!dotsEl) { return; }
    if (String(n) !== dotSig) { dotSig = String(n); dotsEl.innerHTML = n > 1 ? new Array(n + 1).join('<i></i>') : ''; }
    galActive();
  }
  if (gal) {
    var touched = false, gT = 0;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evn) { gal.addEventListener(evn, function () { touched = true; }, { passive: true }); });
    gal.addEventListener('scroll', function () {
      if (touched && gal.scrollLeft > 20 && hint) { hint.classList.add('u-gone'); }
      clearTimeout(gT); gT = setTimeout(galActive, 60);
    }, { passive: true });
    if (hint) {
      hint.addEventListener('click', function () {
        var first = slides()[0];
        var w = first ? first.getBoundingClientRect().width + 10 : gal.clientWidth;
        try { gal.scrollBy({ left: w, behavior: reduce ? 'auto' : 'smooth' }); } catch (e1) { gal.scrollLeft += w; }
        hint.classList.add('u-gone');
      });
    }
    var gv = $$('video', gal);
    if (gv.length && !reduce && 'IntersectionObserver' in W) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var v = en.target;
          if (en.intersectionRatio >= 0.6) { if (v.preload === 'none') { v.preload = 'auto'; } var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: [0, 0.6] });
      gv.forEach(function (v) { v.muted = true; vio.observe(v); });
    }
  }

  /* ── the phone's float bar: after the real button scrolled past, phone widths only (as the case page) ── */
  var mqBar = W.matchMedia ? W.matchMedia('(max-width: 1023px)') : null;
  function floatApply() {
    if (!fBar) { return; }
    var r = cta.getBoundingClientRect();
    /* owner 2026-10-25: the bar shows from the first paint and steps out only while the inline button is on screen */
    var vh = W.innerHeight || D.documentElement.clientHeight;
    var show = !(r.bottom > 0 && r.top < vh) && !cta.disabled && (!mqBar || mqBar.matches);
    fBar.classList.toggle('u-on', show);
    fBar.classList.toggle('is-visible', show);
    fBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  if (fBar) {
    if ('IntersectionObserver' in W) { new IntersectionObserver(floatApply, { threshold: 0 }).observe(cta); }
    W.addEventListener('scroll', floatApply, { passive: true });
    W.addEventListener('resize', floatApply);
    if (mqBar) { try { mqBar.addEventListener('change', floatApply); } catch (eQ) { if (mqBar.addListener) { mqBar.addListener(floatApply); } } }
  }
  if (fCta) { fCta.addEventListener('click', function () { if (!fCta.disabled) { cta.click(); } }); }

  /* ── the phone sheet (the case page's, over the hidden select; a pick navigates to that phone's product) ── */
  var devSel = $('select[data-pr-device]');
  if (devSel) {
    devSel.addEventListener('change', function () {
      if (!devSel.value || devSel.value === data.handle) { return; }
      var to = '/products/' + devSel.value;
      W.location.href = W.mfHref ? W.mfHref(to) : to;
    });
    var items = [], pos = 0, seen = {};
    $$('optgroup', devSel).forEach(function (og) {
      $$('option', og).forEach(function (o) {
        var full = String(o.textContent || '').trim(), br = og.label;
        var lab = String(o.getAttribute('data-label') || '').trim() || full;
        var it = { label: lab, full: full, value: o.value, brand: br, bk: String(br).toLowerCase().replace(/[^a-z0-9]+/g, '-'), pos: pos++ };
        it.pinned = it.pos === 0 && it.value === data.handle;
        items.push(it);
        seen[it.value] = (seen[it.value] || 0) + 1;
      });
    });
    items = items.filter(function (it) { return !(it.pinned && seen[it.value] > 1); });
    var foldL = function (t) { return String(t || '').toLowerCase().replace(/ /g, ''); };
    var loose = function (f) { return f.replace(/\([^)]*\)/g, '').replace(/plus$/, '+').replace(/(4g|5g)(\/(4g|5g))?$/, ''); };
    var family = function (f) { return f.replace(/\d.*$/, ''); };
    /* the device menu sheet's rows (#devices, snippets/up-devices): its order, and its spelling for a row it lists */
    var menuIdx = {}, menuLoose = {}, menuTxt = [];
    [].forEach.call(D.querySelectorAll('#devices .u-devlist > a[data-fold][data-b]'), function (a, n) {
      var b = a.getAttribute('data-b'), f = a.getAttribute('data-fold') || '';
      menuTxt[n] = String(a.textContent || '').trim();
      if (!b) { return; }
      (menuIdx[b] = menuIdx[b] || {})[f] = n;
      menuLoose[b] = menuLoose[b] || {};
      if (!(loose(f) in menuLoose[b])) { menuLoose[b][loose(f)] = n; }
    });
    var byBrand = {}, brandOrder = [];
    items.forEach(function (it) {
      if (!byBrand[it.bk]) { byBrand[it.bk] = []; brandOrder.push(it.bk); }
      byBrand[it.bk].push(it);
    });
    brandOrder.forEach(function (bk) {
      var list = byBrand[bk], mi = menuIdx[bk] || {}, ml = menuLoose[bk] || {};
      list.forEach(function (it) {
        var f = foldL(it.label), n = mi[f];
        if (typeof n !== 'number') { n = ml[loose(f)]; }
        it.mi = (typeof n === 'number') ? n : null;
        /* the menu's spelling where it lists the phone; else the metafield's, a glued model word split ('17Air') */
        if (it.mi !== null && menuTxt[it.mi]) { it.label = menuTxt[it.mi]; } else { it.label = it.label.replace(/(\d)([A-Z][a-z])/g, '$1 $2'); }
        it.fam = family(f);
      });
      list.forEach(function (it, j) {
        if (it.mi !== null) { it.key = it.mi; return; }
        if (it.pinned) { it.key = -1; return; }
        var k = null;
        [true, false].forEach(function (same) {
          var a;
          for (a = j - 1; a >= 0 && k === null; a--) { if (!list[a].pinned && list[a].mi !== null && (!same || list[a].fam === it.fam)) { k = list[a].mi - 0.5; } }
          for (a = j + 1; a < list.length && k === null; a++) { if (list[a].mi !== null && (!same || list[a].fam === it.fam)) { k = list[a].mi + 0.5; } }
        });
        it.key = k === null ? 1e6 - it.pos : k;
      });
      list.sort(function (x, y) { return (x.key - y.key) || (y.pos - x.pos); });
    });
    var BR = ['apple', 'samsung', 'xiaomi', 'huawei'];
    var brands = BR.filter(function (b) { return !!byBrand[b]; })
      .concat(brandOrder.filter(function (b) { return BR.indexOf(b) === -1; }));
    items = [];
    brands.forEach(function (b) { items = items.concat(byBrand[b]); });
    var cur = items.filter(function (it) { return it.value === devSel.value; })[0];
    var activeBrand = cur ? cur.bk : brands[0];
    var bEl = $('[data-upda-brands]'), lEl = $('[data-upda-devlist]'), qEl = $('[data-upda-dq]');
    var fold = function (t) { return String(t || '').toLowerCase().replace(/\s+/g, ''); };
    if (bEl) {
      bEl.style.setProperty('--u-bn', String(Math.min(brands.length, 4)));
      bEl.classList.toggle('u-scroll', brands.length > 4);
      bEl.innerHTML = brands.map(function (b) { return '<button type="button" aria-pressed="false" data-b="' + esc(b) + '">' + esc(byBrand[b][0].brand) + '</button>'; }).join('');
    }
    var renderDev = function () {
      if (!bEl || !lEl) { return; }
      var q = qEl ? fold(qEl.value) : '';
      bEl.hidden = !!q || brands.length < 2;
      $$('[data-b]', bEl).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-b') === activeBrand)); });
      var list = items.filter(function (it) { return q ? fold(it.full).indexOf(q) !== -1 || fold(it.label).indexOf(q) !== -1 : it.bk === activeBrand; });
      lEl.innerHTML = list.length
        ? list.map(function (it) { return '<button type="button" data-dev="' + esc(it.value) + '" aria-current="' + (it.value === devSel.value) + '">' + esc(it.label) + '</button>'; }).join('')
        : '<p class="u-lead u-upd-devnone">' + esc(T('up.pdp.dev_none', { q: qEl ? qEl.value : '' })) + '</p>';
    };
    if (bEl) { bEl.addEventListener('click', function (ev) { var b = ev.target.closest('[data-b]'); if (b) { activeBrand = b.getAttribute('data-b'); renderDev(); } }); }
    if (qEl) { qEl.addEventListener('input', renderDev); }
    if (lEl) {
      lEl.addEventListener('click', function (ev) {
        var b = ev.target.closest('[data-dev]');
        if (!b) { return; }
        var h = b.getAttribute('data-dev');
        if (h === devSel.value) { if (W.upPanel) { W.upPanel.close(); } return; }
        devSel.value = h;
        devSel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    D.addEventListener('u:panel-open', function (ev) {
      if (!ev.detail || ev.detail.id !== 'upd-dev') { return; }
      if (qEl) { qEl.value = ''; }
      activeBrand = cur ? cur.bk : brands[0];
      renderDev();
      var on = bEl && bEl.querySelector('[aria-pressed="true"]');
      if (on && bEl.classList.contains('u-scroll')) { var over = on.getBoundingClientRect().right - bEl.getBoundingClientRect().right; if (over > 0) { bEl.scrollLeft += over + 3; } }
    });
  }
  /* the sheet's opener says whether it is open */
  function expanded(id, on) { $$('[data-u-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  D.addEventListener('u:panel-open', function (ev) { if (ev.detail && ev.detail.id === 'upd-dev') { expanded('upd-dev', true); } });
  D.addEventListener('u:panel-close', function (ev) { if (ev.detail && ev.detail.id === 'upd-dev') { expanded('upd-dev', false); } });

  /* ════════ THE ADD - glossy-color's one line, the new page's mechanics (the case flow above, minus gift/protectors) ════════ */
  var pendingSections = null;
  function openDrawer() { var dr = D.querySelector('cart-drawer'); if (dr) { dr.open = true; } return dr; }
  function beginAdd() {
    var dr = D.querySelector('cart-drawer');
    if (!dr) { return; }
    dr.classList.add('is-adding');
    dr.open = true;
    clearTimeout(dr._prBusy);
    dr._prBusy = setTimeout(function () { dr.classList.remove('is-adding'); }, 8000);
  }
  function endAdd(failed) {
    var dr = D.querySelector('cart-drawer');
    if (!dr) { return; }
    clearTimeout(dr._prBusy);
    dr.classList.remove('is-adding');
    if (failed) { dr.open = false; }
  }
  D.documentElement.addEventListener('cart-drawer:loaded', function () { endAdd(false); });
  function afterAdd(addData) {
    var sections = pendingSections;
    pendingSections = null;
    if (W.mfCart) { W.mfCart.invalidate(); }
    var painted = !!(sections && sections['mini-cart']);
    if (painted) {
      var added = 0;
      if (addData && Array.isArray(addData.items)) { addData.items.forEach(function (line) { added += (line.quantity || 0); }); }
      var known = W.mfCart ? W.mfCart.count() : 0;
      D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: { item_count: (known || 0) + added, sections: sections } } }));
    }
    openDrawer();
    var load = W.mfCart ? W.mfCart.get() : fetch('/cart.js').then(function (r) { return r.json(); });
    return load.then(function (cart) {
      if (cart.item_count > 0) { $$('cart-count.visually-hidden', D).forEach(function (el) { el.classList.remove('visually-hidden'); }); }
      D.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      if (!painted) {
        D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        openDrawer();
      }
    });
  }
  function showAddError(message) {
    $$('[data-upda-err]').forEach(function (el) {
      el.textContent = message;
      el.hidden = false;
      clearTimeout(el._prTimer);
      el._prTimer = setTimeout(function () { el.hidden = true; }, 6000);
    });
  }
  function sendAdd(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items, sections: 'mini-cart' }) });
  }
  function postItems(items) {
    pendingSections = null;
    return sendAdd(items)
      .then(function (response) {
        if (response.status !== 429) { return response; }
        return new Promise(function (res) { setTimeout(res, 1200); }).then(function () { return sendAdd(items); });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            showAddError(response.status === 429 ? data.errBusy : ((body && body.description) || data.errGeneric));
            throw new Error('cart/add.js returned ' + response.status);
          });
        }
        return response.json().then(function (d) { if (d && d.sections) { pendingSections = d.sections; } return d; }).catch(function () { return null; });
      });
  }
  /* glossy's first-party surface counter: fire-and-forget, nothing personal, the item_add family (never the case
     page's 'adds' counter) */
  function surfaceBeacon() {
    try {
      if (!navigator.sendBeacon || !data.beaconUrl) { return; }
      navigator.sendBeacon(data.beaconUrl, new Blob([JSON.stringify({
        kind: 'item_add', surface: String(data.surface || 'protector_pdp'), product: String(data.handle || ''),
        c: data.shop,
        vp: W.innerWidth < 768 ? 'mobile' : (W.innerWidth < 1024 ? 'tablet' : 'desktop')
      })], { type: 'text/plain' }));
    } catch (e) {}
  }
  cta.addEventListener('click', function () {
    var variantId = parseInt(cta.getAttribute('data-variant-id'), 10);
    if (!variantId || cta.disabled || cta.getAttribute('aria-busy') === 'true') { return; }
    cta.setAttribute('aria-busy', 'true');
    beginAdd();
    postItems([{ id: variantId, quantity: 1 }])
      .then(function (r) { surfaceBeacon(); return afterAdd(r); })
      .catch(function (err) {
        if (W.console) { console.error('Add to cart error:', err); }
        endAdd(true);
        if (String(err && err.message).indexOf('cart/add.js returned') !== 0) { showAddError(data.errGeneric); }
      })
      .then(function () { cta.removeAttribute('aria-busy'); });
  });

  /* ── boot ── */
  update();
  /* QA hook */
  W.__upPdpAcc = { pick: pick, resolve: resolve, update: update, money: money };
})();
